var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { reactive, computed, createApp, defineAsyncComponent } from "vue";
import { C as Capacitor, aU as src_default, aV as setTag$1, aW as captureMessage$1, aX as captureException$1, aY as browserTracingIntegration, aZ as browserProfilingIntegration, a_ as replayIntegration, a$ as init, b0 as setUser$1, b1 as api, ae as jwtDecode, b2 as useFavicon, t as toZonedTime, o as format, b3 as Badge, b4 as FCM, b5 as PushNotifications, g as registerPlugin, b6 as App, b7 as Y, b8 as l, b9 as G, ba as addBreadcrumb, bb as setContext, bc as withScope, a as axios } from "./vendor-DtHBi3De.js";
import "firebase/compat/auth";
import "@gohighlevel/ghl-ui";
import { string } from "yup";
import { initializeAuth, browserLocalPersistence, signInWithCustomToken } from "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
const crypto = window.crypto || window.msCrypto;
const deviceId = (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(
  /[018]/g,
  (c) => {
    const randomChars = crypto.getRandomValues(new Uint8Array(1));
    return (Number(c) ^ randomChars[0] & 15 >> Number(c) / 4).toString(16);
  }
);
function isMobileTablet() {
  let check = false;
  (function(a) {
    if (
      /* eslint-disable-next-line */
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) || /* eslint-disable-next-line */
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
function isMobileOs() {
  const isAndroid = /Android/.test(navigator.userAgent);
  const isIOS = /iPhone|iPad/.test(navigator.userAgent);
  if (isAndroid || isIOS) {
    return true;
  } else {
    return false;
  }
}
function isWebKit() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isSafari || isIOS) {
    return true;
  } else {
    return false;
  }
}
function isPwa() {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  if (window.navigator.standalone || isStandalone) {
    return true;
  } else if (Capacitor.isNativePlatform()) {
    return true;
  }
  return false;
}
function isThirdPartyInAppBrowser() {
  if (Capacitor.isNativePlatform()) {
    return false;
  }
  const { isInApp } = src_default();
  return isInApp;
}
function handleRedirectToExternalBrowser() {
  const url = window.location.href;
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isAndroid) {
    const intentUrl = `intent://${url.replace(
      /^https?:\/\//,
      ""
    )}#Intent;scheme=https;end`;
    window.location.href = intentUrl;
  } else if (isIOS) {
    window.location.href = "x-safari-" + url;
  }
}
function getDevicePlatform() {
  var _a, _b;
  try {
    return ((_a = Capacitor) == null ? void 0 : _a.getPlatform()) ? (_b = Capacitor) == null ? void 0 : _b.getPlatform() : isMobileTablet() ? "mobile" : "desktop";
  } catch (error) {
    console.error("Error getting device platform:", error);
    return null;
  }
}
var ClientPortalApps = /* @__PURE__ */ ((ClientPortalApps2) => {
  ClientPortalApps2["CLIENT_PORTAL"] = "clientPortal";
  ClientPortalApps2["CLIENT_PORTAL_MOBILE"] = "clientPortalMobile";
  ClientPortalApps2["COMMUNITIES"] = "communities";
  ClientPortalApps2["COURSES"] = "courses";
  ClientPortalApps2["GOKOLLAB"] = "gokollab";
  ClientPortalApps2["GOKOLLAB_COMMUNITIES"] = "gokollab-communities";
  ClientPortalApps2["GOKOLLAB_COURSES"] = "gokollab-courses";
  ClientPortalApps2["AFFILIATES"] = "affiliates";
  return ClientPortalApps2;
})(ClientPortalApps || {});
const sentryInitConfig = {
  [ClientPortalApps.CLIENT_PORTAL]: "https://f608faa4c2b4a49c7ab987a0670a7ba0@o176457.ingest.us.sentry.io/4509090683289600",
  [ClientPortalApps.CLIENT_PORTAL_MOBILE]: "https://29b2458fc03c07d3efd389750587d928@o176457.ingest.us.sentry.io/4509110789341184",
  [ClientPortalApps.COMMUNITIES]: "https://64640a42997c80b0114e7952a1df2df6@o176457.ingest.us.sentry.io/4509189719195649",
  [ClientPortalApps.COURSES]: "https://1a7a2b037047592efa30e3e3b35aad83@o176457.ingest.us.sentry.io/4509189711921152",
  [ClientPortalApps.GOKOLLAB]: "https://1022e834adb171318bc36d230c1feefe@o176457.ingest.us.sentry.io/4509189796134912",
  [ClientPortalApps.AFFILIATES]: "https://21e6de9fee1b8fbcd97382a069ca4ab9@o176457.ingest.us.sentry.io/4509571159687168"
};
const sentryProductionDefaults = {
  sampleRate: 0.01,
  tracesSampleRate: 0.05,
  profilesSampleRate: 0.05,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5
};
const sentryDevOrStagingDefaults = {
  sampleRate: 0.01,
  tracesSampleRate: 0.01,
  profilesSampleRate: 0.01,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0
};
const firebaseStagingConfig = {
  apiKey: "AIzaSyBq1AW1-hxC_PY9QNPKm3X75ObEMMZItIQ",
  authDomain: "highlevel-staging.firebaseapp.com",
  databaseURL: "https://highlevel-staging.firebaseio.com",
  projectId: "highlevel-staging",
  storageBucket: "highlevel-staging.appspot.com",
  messagingSenderId: "85350210461",
  appId: "1:85350210461:web:d3728d34bf8bd6b5",
  cdnUrl: "https://staging.cdn.apisystem.tech",
  assetsUrl: "https://staging.cdn.apisystem.tech",
  oldCdnUrl: "https://staging.cdn.msgsndr.com",
  membershipCdnUrl: "https://staging.cdnmembership.apisystem.tech",
  membershipStorageBucket: "revex-membership-staging"
};
const firebaseProductionConfig = {
  apiKey: "AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE",
  authDomain: "highlevel-backend.firebaseapp.com",
  databaseURL: "https://highlevel-backend.firebaseio.com",
  projectId: "highlevel-backend",
  storageBucket: "highlevel-backend.appspot.com",
  messagingSenderId: "439472444885",
  appId: "1:439472444885:web:6fa4c26d1bcbeb87",
  cdnUrl: "https://cdn.apisystem.tech",
  assetsUrl: "https://staging.cdn.apisystem.tech",
  oldCdnUrl: "https://cdn.msgsndr.com",
  membershipCdnUrl: "https://cdn.courses.apisystem.tech",
  membershipStorageBucket: "revex-membership-production"
};
const config = {
  development: {
    mode: "dev",
    // REST_API_URLS: 'http://localhost:9611',
    OLD_API_URLS: "https://staging.backend.leadconnectorhq.com",
    REST_API_URLS: "https://staging.services.leadconnectorhq.com",
    DOCUMENT_MANAGEMENT_SERVICE: "https://staging.services.leadconnectorhq.com/documents",
    COMMUNITIES_API_URL: "https://staging.services.leadconnectorhq.com/communities",
    GOKOLLAB_SERVER_URL: "http://localhost:5501/gokollab",
    INTERNAL_URL: "http://localhost:9611/clientclub",
    CLIENT_PORTAL_SSO_URL: "https://staging.sso.clientclub.net",
    firebase: firebaseStagingConfig,
    ASSETS_URL: "https://storage.googleapis.com/revex-client-portal-staging",
    domain: "communities.staging.clientclub.net",
    reCaptchaDomain: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
    certificatesRegistryDomain: "staging.my-certificates.com",
    webPushCertificate: "BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4",
    KOLLAB_GOOGLE_CLIENT_ID: "548660082635-bvh6gae5e8om7ej9vkls4grkgee77mav.apps.googleusercontent.com",
    GOKOLLAB_LOCATION_ID: "bb1S8LPFpG3PEWJBMaNm",
    GOKOLLAB_ASSETS_BUCKET_URL: "https://storage.googleapis.com/revex-gokollab-staging/assets",
    SENTRY_DSN: sentryInitConfig,
    SENTRY_DEFAULTS: sentryDevOrStagingDefaults
  },
  staging: {
    mode: "staging",
    OLD_API_URLS: "https://staging.backend.leadconnectorhq.com",
    REST_API_URLS: "https://staging.services.leadconnectorhq.com",
    DOCUMENT_MANAGEMENT_SERVICE: "https://staging.services.leadconnectorhq.com/documents",
    COMMUNITIES_API_URL: "https://staging.services.leadconnectorhq.com/communities",
    GOKOLLAB_SERVER_URL: "https://staging.services.leadconnectorhq.com/gokollab",
    INTERNAL_URL: "https://staging.services.leadconnectorhq.com/clientclub",
    CLIENT_PORTAL_SSO_URL: "https://staging.sso.clientclub.net",
    firebase: firebaseStagingConfig,
    ASSETS_URL: "https://storage.googleapis.com/revex-client-portal-staging",
    domain: "communities.staging.clientclub.net",
    reCaptchaDomain: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
    certificatesRegistryDomain: "staging.my-certificates.com",
    webPushCertificate: "BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4",
    KOLLAB_GOOGLE_CLIENT_ID: "548660082635-bvh6gae5e8om7ej9vkls4grkgee77mav.apps.googleusercontent.com",
    GOKOLLAB_LOCATION_ID: "bb1S8LPFpG3PEWJBMaNm",
    GOKOLLAB_ASSETS_BUCKET_URL: "https://storage.googleapis.com/revex-gokollab-staging/assets",
    SENTRY_DSN: sentryInitConfig,
    SENTRY_DEFAULTS: sentryDevOrStagingDefaults
  },
  production: {
    mode: "production",
    OLD_API_URLS: "https://backend.leadconnectorhq.com",
    REST_API_URLS: "https://services.leadconnectorhq.com",
    DOCUMENT_MANAGEMENT_SERVICE: "https://services.leadconnectorhq.com/documents",
    COMMUNITIES_API_URL: "https://services.leadconnectorhq.com/communities",
    GOKOLLAB_SERVER_URL: "https://services.leadconnectorhq.com/gokollab",
    INTERNAL_URL: "https://services.leadconnectorhq.com/clientclub",
    CLIENT_PORTAL_SSO_URL: "https://sso.clientclub.net",
    firebase: firebaseProductionConfig,
    ASSETS_URL: "https://storage.googleapis.com/revex-client-portal-staging",
    reCaptchaDomain: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
    certificatesRegistryDomain: "my-certificates.com",
    KOLLAB_GOOGLE_CLIENT_ID: "548660082635-l46f0u8vlh1pioo8nbvall05c9drilkk.apps.googleusercontent.com",
    GOKOLLAB_LOCATION_ID: "VyoxA4YGXCZib071EFsR",
    GOKOLLAB_ASSETS_BUCKET_URL: "https://storage.googleapis.com/revex-gokollab-production/assets",
    SENTRY_DSN: sentryInitConfig,
    SENTRY_DEFAULTS: sentryProductionDefaults
  }
};
const ENVIRONMENT = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  SANDBOX: "sandbox",
  PRODUCTION: "production"
};
const MAX_REGISTER_PUSH_TOKEN_RETRIES = 3;
const CLOUD_ASSETS_URL = `${config.development.ASSETS_URL}/assets`;
const LANDING_PAGE_IMAGE = `${CLOUD_ASSETS_URL}/landing_page_image.svg`;
const FACEBOOK_ICON = `${CLOUD_ASSETS_URL}/facebook.svg`;
const INSTAGRAM_ICON = `${CLOUD_ASSETS_URL}/instagram.svg`;
const LINKEDIN_ICON = `${CLOUD_ASSETS_URL}/linkedin.svg`;
const TWITTER_ICON = `${CLOUD_ASSETS_URL}/x-twitter.svg`;
const YOUTUBE_ICON = `${CLOUD_ASSETS_URL}/youtube.svg`;
const LOCKOUT_IMAGE = `${CLOUD_ASSETS_URL}/lockout.svg`;
const COURSES_ICON = `${CLOUD_ASSETS_URL}/courses_icon.svg`;
const COMMUNITIES_ICON = `${CLOUD_ASSETS_URL}/community_icon.svg`;
const DEFAULT_COVER = `${CLOUD_ASSETS_URL}/default_cover.png`;
const DEFAULT_AVATAR = `${CLOUD_ASSETS_URL}/default_avatar.png`;
const EMPTY_FOLDER = `${CLOUD_ASSETS_URL}/empty_folder.svg`;
const EMPTY_STATE = `${CLOUD_ASSETS_URL}/empty_state.svg`;
const KOLAB_IMAGE = `${CLOUD_ASSETS_URL}/kollab_image.svg`;
const VISA_ICON = `${CLOUD_ASSETS_URL}/visa.svg`;
const MASTERCARD_ICON = `${CLOUD_ASSETS_URL}/mastercard.svg`;
const AMEX_ICON = `${CLOUD_ASSETS_URL}/amex.svg`;
const DINERS_ICON = `${CLOUD_ASSETS_URL}/diners.svg`;
const DISCOVER_ICON = `${CLOUD_ASSETS_URL}/discover.svg`;
const JCB_ICON = `${CLOUD_ASSETS_URL}/jcb.svg`;
const UNIONPAY_ICON = `${CLOUD_ASSETS_URL}/unionpay.svg`;
const CARD_ICON = `${CLOUD_ASSETS_URL}/card.svg`;
const ALLOWED_FILE_TYPES = [
  "image/svg+xml",
  "image/png",
  "image/webp",
  "image/jpg",
  "image/jpeg"
];
var ProfileScreen = /* @__PURE__ */ ((ProfileScreen2) => {
  ProfileScreen2["BILLING_SUBSCRIPTION"] = "BillingSubscription";
  ProfileScreen2["AUTH_PAGE"] = "AuthPage";
  ProfileScreen2["EDIT_BASIC_INFO"] = "EditBasicInfo";
  ProfileScreen2["EDIT_DETAILS"] = "EditDetails";
  ProfileScreen2["EDIT_ACCOUNT"] = "EditAccount";
  ProfileScreen2["EDIT_PROFILE"] = "EditProfile";
  ProfileScreen2["SETTINGS_MENU"] = "SettingsMenu";
  ProfileScreen2["SUBSCRIPTION_DETAIL"] = "SubscriptionDetail";
  ProfileScreen2["COMMUNITIES_CHATS"] = "CommunitiesChats";
  ProfileScreen2["LANGUAGE_SETTINGS"] = "LanguageSettings";
  ProfileScreen2["PAYMENT_METHODS"] = "PaymentMethods";
  ProfileScreen2["CERTIFICATES"] = "Certificates";
  ProfileScreen2["NOTIFICATION_SETTINGS"] = "NotificationSettings";
  ProfileScreen2["PUSH_NOTIFICATIONS_PREFERENCES"] = "PushNotificationsPreferences";
  ProfileScreen2["EMAIL_NOTIFICATIONS_PREFERENCES"] = "EmailNotificationsPreferences";
  return ProfileScreen2;
})(ProfileScreen || {});
var EstimateStatus = /* @__PURE__ */ ((EstimateStatus2) => {
  EstimateStatus2["ACCEPTED"] = "accepted";
  return EstimateStatus2;
})(EstimateStatus || {});
var ForceUpdateEvents = /* @__PURE__ */ ((ForceUpdateEvents2) => {
  ForceUpdateEvents2["FORCE_UPDATE_BUTTON_CLICKED"] = "force_update_button_clicked";
  ForceUpdateEvents2["FORCE_UPDATE_SUCCESSFUL"] = "force_update_successful";
  ForceUpdateEvents2["FORCE_UPDATE_SCREEN_SEEN"] = "force_update_screen_seen";
  return ForceUpdateEvents2;
})(ForceUpdateEvents || {});
const FORCE_UPDATE_TRACKING_KEY = "force_update_tracking";
const GTagID = "G-91CZG6XDY5";
const GOKOLLAB_GTagID = "G-C0S0S6XVMF";
const COURSES_GTagID = "G-WWDNWPX8Z2";
const CP_GOKOLLAB_GTagID = "G-VWZEF00Q3B";
var Screens = /* @__PURE__ */ ((Screens2) => {
  Screens2["LOGIN"] = "LOGIN";
  Screens2["LOGIN_WITH_EMAIL"] = "LOGIN_WITH_EMAIL";
  Screens2["LOGIN_WITH_SECURE_CODE"] = "LOGIN_WITH_SECURE_CODE";
  Screens2["SET_PASSWORD_WITH_SECURE_CODE"] = "SET_PASSWORD_WITH_SECURE_CODE";
  Screens2["VERIFY_SECURE_CODE"] = "VERIFY_SECURE_CODE";
  Screens2["SELECT_USER_MULTI_USER"] = "SELECT_USER_MULTI_USER";
  Screens2["SIGN_UP"] = "SIGN_UP";
  Screens2["SET_PASSWORD"] = "SET_PASSWORD";
  Screens2["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
  Screens2["PROCEED_TO_LOGIN"] = "PROCEED_TO_LOGIN";
  Screens2["TERMS_CONSENT"] = "TERMS_CONSENT";
  return Screens2;
})(Screens || {});
const DEFAULT_GROUP_COVER_IMAGE = "https://storage.googleapis.com/highlevel-staging.appspot.com/communities/sTPu59jO68qjLE5h10Ny/groups/02571fec-cf90-4db9-8bce-e0b4a6669c57";
const DEFAULT_GROUP_LOGO = "https://storage.googleapis.com/highlevel-staging.appspot.com/communities/sTPu59jO68qjLE5h10Ny/groups/255f2156-6614-4f6c-9229-b014960fd2aa";
const GOKOLLAB_GRADIENT_LOGO = {
  DARK: "https://storage.googleapis.com/revex-gokollab-staging/assets/gokollab-logo-dark-theme-v4.webp",
  LIGHT: "https://storage.googleapis.com/revex-gokollab-staging/assets/gokollab-logo-light-theme-v4.webp"
};
const GOKOLLAB_LOGO = {
  LIGHT: "https://storage.googleapis.com/revex-gokollab-staging/assets/gokollab-logo-light-theme-v4.webp"
};
const DEFAULT_COMMUNITY_LOGO = "https://storage.googleapis.com/revex-gokollab-staging/assets/default-community-logo.webp";
const DEFAULT_COURSE_LOGO = "https://storage.googleapis.com/revex-gokollab-staging/assets/default-courses-logo.webp";
const GOKOLLAB_DEFAULT_LOGO = "https://storage.googleapis.com/revex-gokollab-staging/assets/gokollab-logo-light-theme-v4.webp";
const GOKOLLAB_MASTERMIND_LOGO = "https://storage.googleapis.com/revex-gokollab-staging/assets/gokollab-mastermin-logo-v4.webp";
const GOKOLLAB_K_LOGO_WITHOUT_BORDER = "https://storage.googleapis.com/revex-gokollab-staging/assets/gokollab-without-border-v4.png";
const ADD_ICON = "https://storage.googleapis.com/staging-revex-gokollab-preview/assets/AddIcon.svg";
const EXPLORE_ICON = "https://storage.googleapis.com/staging-revex-gokollab-preview/assets/Explore.svg";
const LOGIN_LOGO = "https://storage.googleapis.com/revex-gokollab-staging/assets/login-logo.svg";
const SIGN_UP_LOGO = "https://storage.googleapis.com/revex-gokollab-staging/assets/sign-up-logo.svg";
const GROUP_BRANDING_NAVBAR = `${CLOUD_ASSETS_URL}/group_branding_navbar.svg`;
const FRAME1 = `${CLOUD_ASSETS_URL}/frame1.svg`;
const FRAME2 = `${CLOUD_ASSETS_URL}/frame2.svg`;
const FRAME3 = `${CLOUD_ASSETS_URL}/frame3.svg`;
const FRAME4 = `${CLOUD_ASSETS_URL}/frame4.svg`;
const GROUP_MOBILE_ICON = `${CLOUD_ASSETS_URL}/group_mobile.svg`;
const MAIL_MOBILE_ICON = `${CLOUD_ASSETS_URL}/mail_mobile.svg`;
const TEST_LOCATION_ID = "hMDUTOU6bIG4hXRzXQKm";
const TEST_EMAIL_ID = "appletestkb@gmail.com";
const BRANDED_TEST_EMAIL_ID = "sakshi.ajmera111@gmail.com";
const TEST_EMAILS = [
  "appletestkb@gmail.com",
  "sakshi.ajmera111@gmail.com",
  "appletestapp83@gmail.com"
];
const MAX_BADGE_COUNT_LIMIT = 100;
const CAPACITOR_PLATFORM = {
  ANDROID: "android",
  IOS: "ios"
};
var CPPageEvents = /* @__PURE__ */ ((CPPageEvents2) => {
  CPPageEvents2["USER_PAGE_HIT"] = "clientportal_user_page_hit";
  CPPageEvents2["CLIENT_PORTAL_ESTIMATE_DOWNLOAD"] = "clientportal_estimate_download";
  CPPageEvents2["CLIENT_PORTAL_ESTIMATE_VIEW"] = "clientportal_estimate_view";
  CPPageEvents2["CLIENT_PORTAL_CONTRACT_DOWNLOAD"] = "clientportal_contract_download";
  CPPageEvents2["CLIENT_PORTAL_CONTRACT_VIEW"] = "clientportal_contract_view";
  CPPageEvents2["CLIENT_PORTAL_SHARED_FILE_DOWNLOAD"] = "clientportal_shared_file_download";
  CPPageEvents2["CLIENT_PORTAL_SHARED_FILE_VIEW"] = "clientportal_shared_file_view";
  return CPPageEvents2;
})(CPPageEvents || {});
var UserPlatform = /* @__PURE__ */ ((UserPlatform2) => {
  UserPlatform2["WEB"] = "web";
  UserPlatform2["PWA"] = "pwa";
  return UserPlatform2;
})(UserPlatform || {});
var CP_Pendo_Events = /* @__PURE__ */ ((CP_Pendo_Events2) => {
  CP_Pendo_Events2["USER_NOTIFICATION_PREFERENCES_UPDATED"] = "clientportal_user_notification_preferences_updated";
  return CP_Pendo_Events2;
})(CP_Pendo_Events || {});
const OpenInNativeAppWhitelist = {
  // Email platforms
  mailto: /^mailto:/,
  gmail: /^https?:\/\/(?:.*\.)?gmail\.com/,
  outlook: /^https?:\/\/(?:.*\.)?outlook\.com/,
  yahoo: /^https?:\/\/(?:.*\.)?mail\.yahoo\.com/,
  // Video/conferencing platforms
  youtube: /^https?:\/\/((?:www\.)?youtube\.com|youtu\.be)/,
  vimeo: /^https?:\/\/(?:.*\.)?vimeo\.com/,
  zoom: /^https?:\/\/(?:.*\.)?zoom\.us/,
  meet: /^https?:\/\/meet\.google\.com/,
  // Messaging platforms
  telegram: /^https?:\/\/(?:.*\.)?telegram\.me/,
  whatsapp: /^https?:\/\/(?:.*\.)?wa\.me/,
  discord: /^https?:\/\/(?:.*\.)?discord\.com/,
  // File sharing/docs
  gdrive: /^https?:\/\/(?:.*\.)?drive\.google\.com/,
  gdocs: /^https?:\/\/(?:.*\.)?docs\.google\.com/,
  // Social media platforms
  facebook: /^https?:\/\/(?:.*\.)?facebook\.com/,
  instagram: /^https?:\/\/(?:.*\.)?instagram\.com/,
  linkedin: /^https?:\/\/(?:.*\.)?linkedin\.com/,
  // Helper method to check if URL matches any whitelist pattern
  matchesAny(url) {
    return Object.values(this).filter((value) => value instanceof RegExp).some((pattern) => pattern.test(url));
  }
};
const DEFAULT_CERTIFICATE_THUMBNAIL = "https://storage.googleapis.com/revex-certificates-production/assets/certificate-thumbnail-landscape.svg";
const NO_CERTIFICATES_THUMBNAIL = "https://storage.googleapis.com/revex-certificates-production/assets/no-certificates-thumbnail.svg";
const GL_APP_STORE_LINK = "https://apps.apple.com/in/app/gokollab/id6484272411";
const GL_PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=net.clientclub.app.kollab";
const FORCE_APP_UPDATE_BG = "https://storage.googleapis.com/revex-client-portal-production/assets/force-app-update-bg.png";
const WINDOW_EVENTS = {
  TOUCH_START: "touchstart",
  TOUCH_MOVE: "touchmove"
};
var TokenRefreshStatus = /* @__PURE__ */ ((TokenRefreshStatus2) => {
  TokenRefreshStatus2["REFRESHING"] = "REFRESHING";
  TokenRefreshStatus2["PENDING_RETRY"] = "PENDING_RETRY";
  return TokenRefreshStatus2;
})(TokenRefreshStatus || {});
const FCM_TOKEN_REFRESH_WAIT_TIME = 4e4;
const FCM_TOKEN_REFRESH_STORAGE_KEY = "fcm_token_refresh_state";
const NETWORK_ERROR_CODES = {
  ECONNABORTED: "ECONNABORTED",
  ERR_NETWORK: "ERR_NETWORK",
  ERR_INTERNET_DISCONNECTED: "ERR_INTERNET_DISCONNECTED"
};
const SCOPE_LEVEL = {
  WARNING: "warning"
};
const NEWTORK_ERROR_TYPES = {
  CONNECTION_ABORT: "connection_abort"
};
class AppsState {
  constructor() {
    __publicField(this, "state", reactive({
      APP_NAME: "",
      firebaseAuthInstance: null,
      processing: false,
      loading: true,
      locationData: [],
      redirectUrl: "",
      isGokollab: false,
      isLogoutUserCalled: false,
      NODE_ENV: "",
      isTitleEnabled: false,
      billingId: "",
      billingObj: null,
      transactionObj: null,
      isSubscription: true,
      isSSODisabled: false,
      isMobile: window.innerWidth <= 820,
      routerInstance: null,
      authButtonStyle: computed(() => {
        var _a, _b, _c;
        return `background: ${((_c = (_b = (_a = this.state) == null ? void 0 : _a.locationData) == null ? void 0 : _b.branding) == null ? void 0 : _c.brandColor1) + "!important" || "#323076!important"} ;
        color: var(--sidebar-selected-item-font) !important;
        border: none !important;
        }`;
      }),
      secondaryButtonStyle: computed(() => {
        return `background-color: white !important;
        color: "#475467" !important;
        border: none !important;
        }`;
      }),
      childNavigationItems: [],
      isThirdPartyInAppBrowser: computed(() => {
        return isThirdPartyInAppBrowser();
      }),
      appType: null,
      nativeReleaseVersionCode: null,
      nativeAppVersion: ""
    }));
    this.addWindowResizeListener();
  }
  addWindowResizeListener() {
    window.addEventListener("resize", () => {
      this.state.isMobile = window.innerWidth <= 1024;
    });
  }
  getConfig() {
    var _a;
    if (this.state.NODE_ENV) {
      return config[this.state.NODE_ENV];
    }
    try {
      const hostname = ((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname) || "";
      this.state.NODE_ENV = hostname.includes("staging.") ? ENVIRONMENT.STAGING : ENVIRONMENT.PRODUCTION;
      return config[this.state.NODE_ENV];
    } catch (error) {
      return config[ENVIRONMENT.PRODUCTION];
    }
  }
  setRouterInstance(router) {
    this.state.routerInstance = router;
  }
  getRouterInstance() {
    if (!this.state.routerInstance) {
      return false;
    }
    return this.state.routerInstance;
  }
  setAppLoading(value) {
    this.state.loading = value;
  }
  isAppLoading() {
    return this.state.loading;
  }
  setFirebaseAuthInstance(instance) {
    this.state.firebaseAuthInstance = instance;
  }
  getFirebaseAuthInstance() {
    return this.state.firebaseAuthInstance;
  }
}
var LoginEvents = /* @__PURE__ */ ((LoginEvents2) => {
  LoginEvents2["LOGIN_CALLBACK"] = "loginCallback";
  LoginEvents2["LOGIN_SUCCESSFUL"] = "loginSuccessful";
  LoginEvents2["LOGIN_FAILED"] = "loginFailed";
  LoginEvents2["CHANGE_SCREEN"] = "changeScreen";
  return LoginEvents2;
})(LoginEvents || {});
const AppState = new AppsState();
const setAppLoading = (value) => {
  AppState.setAppLoading(value);
};
const isAppLoading = () => {
  return AppState.isAppLoading();
};
var ApplicationStatus = /* @__PURE__ */ ((ApplicationStatus2) => {
  ApplicationStatus2["APPROVED"] = "APPROVED";
  ApplicationStatus2["PENDING"] = "PENDING";
  ApplicationStatus2["PAYMENT_RECEIVED"] = "PAYMENT_RECEIVED";
  ApplicationStatus2["DRAFT"] = "DRAFT";
  ApplicationStatus2["IN_REVIEW"] = "IN_REVIEW";
  ApplicationStatus2["REVIEW_FAILED"] = "REVIEW_FAILED";
  ApplicationStatus2["REVIEW_SUCCESSFUL"] = "REVIEW_SUCCESSFUL";
  ApplicationStatus2["TWO_FA_GRANTED"] = "TWO_FA_GRANTED";
  ApplicationStatus2["APPS_SUBMITTED"] = "APPS_SUBMITTED";
  ApplicationStatus2["APP_LIVE"] = "APP_LIVE";
  ApplicationStatus2["APP_REJECTED"] = "APP_REJECTED";
  ApplicationStatus2["CANCELLED"] = "CANCELLED";
  return ApplicationStatus2;
})(ApplicationStatus || {});
function initSentry(app, options) {
  var _a, _b;
  const environment = ((_b = (_a = options == null ? void 0 : options.environment) == null ? void 0 : _a.trim()) == null ? void 0 : _b.toLowerCase()) || "production";
  const { dsn, hasValidationIssue } = getAndValidateSentryDSN(options);
  const defaultIgnoreErrors = [
    // Network errors
    "NetworkError",
    "Network request failed",
    "Failed to fetch",
    "ERR_NETWORK",
    "ERR_INTERNET_DISCONNECTED",
    "The network connection was lost",
    // Axios specific errors
    "AxiosError: Network Error",
    "Request failed with status code 4",
    // Generic patterns for 4XX errors
    /Request failed with status code 4\d{2}/
  ];
  const combinedIgnoreErrors = [
    ...defaultIgnoreErrors,
    ...(options == null ? void 0 : options.ignoreErrors) || []
  ];
  const combinedBeforeSend = (event, hint) => {
    var _a2, _b2, _c, _d, _e, _f;
    if ((_c = (_b2 = (_a2 = event.exception) == null ? void 0 : _a2.values) == null ? void 0 : _b2[0]) == null ? void 0 : _c.value) {
      const errorMessage = event.exception.values[0].value;
      if (/(?:status code|response code|HTTP)\s*4\d{2}/.test(errorMessage)) {
        return null;
      }
      if (/AxiosError.*(?:status code|response code)\s*4\d{2}/.test(errorMessage)) {
        return null;
      }
    }
    if (hint.originalException && typeof hint.originalException === "object") {
      const error = hint.originalException;
      if (((_d = error == null ? void 0 : error.response) == null ? void 0 : _d.status) && ((_e = error == null ? void 0 : error.response) == null ? void 0 : _e.status) >= 400 && ((_f = error == null ? void 0 : error.response) == null ? void 0 : _f.status) < 500) {
        return null;
      }
      if ((error == null ? void 0 : error.code) === "ERR_NETWORK" || (error == null ? void 0 : error.message) === "Network Error") {
        return null;
      }
    }
    if (options == null ? void 0 : options.beforeSend) {
      return options.beforeSend(event, hint);
    }
    return event;
  };
  const sentryOptions = {
    app,
    Vue: app,
    name: options.appName,
    release: options.release,
    dsn,
    environment,
    integrations: [
      browserTracingIntegration(),
      // tracing
      browserProfilingIntegration(),
      // profiling
      // session replay integration
      replayIntegration({
        maskAllText: true,
        blockAllMedia: false
      })
    ],
    // errors sample rate
    sampleRate: options.sampleRate ?? config[environment].SENTRY_DEFAULTS.sampleRate,
    // tracing
    tracesSampleRate: options.tracesSampleRate ?? config[environment].SENTRY_DEFAULTS.tracesSampleRate,
    // profiling
    profilesSampleRate: options.profilesSampleRate ?? config[environment].SENTRY_DEFAULTS.profilesSampleRate,
    // session replay
    replaysSessionSampleRate: options.replaysSessionSampleRate ?? config[environment].SENTRY_DEFAULTS.replaysSessionSampleRate,
    replaysOnErrorSampleRate: options.replaysOnErrorSampleRate ?? config[environment].SENTRY_DEFAULTS.replaysOnErrorSampleRate,
    ignoreErrors: combinedIgnoreErrors,
    beforeSend: combinedBeforeSend,
    debug: false
  };
  if (options.router) {
    Object.assign(sentryOptions, { router: options.router });
  }
  console.log(" -------- SENTRY OPTIONS -------- ", sentryOptions);
  init(sentryOptions);
  setTag$1("app", (options == null ? void 0 : options.appTag) || (options == null ? void 0 : options.appName));
  if (hasValidationIssue) {
    setTag$1("dsn_validation_issue", "true");
  }
  const developerVersion = getDeveloperVersionFromMeta();
  if (developerVersion) {
    setTag$1("developer_version", developerVersion);
  }
}
function setUser(userId, email) {
  setUser$1({
    id: userId,
    email
  });
}
function captureException(error) {
  captureException$1(error);
}
function captureMessage(message, level = "info") {
  captureMessage$1(message, level);
}
function setTag(key, value) {
  setTag$1(key, value);
}
function getDeveloperVersionFromMeta() {
  try {
    const metaTag = document.querySelector('meta[name="x-developer-version"]');
    return metaTag ? metaTag.getAttribute("content") : null;
  } catch (error) {
    console.error("Error getting developer version from meta tags:", error);
    return null;
  }
}
function getAndValidateSentryDSN(options) {
  var _a, _b;
  let dsn = options.dsn[options.appName] || options.dsn.clientPortal;
  let hasValidationIssue = false;
  try {
    const hostname = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname;
    const pathname = ((_b = window == null ? void 0 : window.location) == null ? void 0 : _b.pathname) || "";
    switch (options.appName) {
      /* keep Gokollab first since it also has courses and communities paths,
       * so this will make sure validation is done correctly
       * This will also make sure when a community or course is opened in a new tab
       * the errors there will still log to goKollab DSN
       */
      case ClientPortalApps.GOKOLLAB:
        if (hostname.endsWith("gokollab.com") && dsn !== options.dsn.gokollab) {
          dsn = options.dsn.gokollab;
          hasValidationIssue = true;
        }
        break;
      case ClientPortalApps.COURSES:
        if (pathname.includes("courses") && dsn !== options.dsn.courses) {
          dsn = options.dsn.courses;
          hasValidationIssue = true;
        }
        break;
      case ClientPortalApps.COMMUNITIES:
        if (pathname.includes("communities") && dsn !== options.dsn.communities) {
          dsn = options.dsn.communities;
          hasValidationIssue = true;
        }
        break;
      case ClientPortalApps.AFFILIATES:
        if (pathname.includes("affiliate") && dsn !== options.dsn.affiliates) {
          dsn = options.dsn.affiliates;
          hasValidationIssue = true;
        }
        break;
      default:
        break;
    }
  } catch (error) {
    hasValidationIssue = true;
    console.error(
      "Error getting and validating sentry DSN so sticking to default clientPortal DSN: ",
      error
    );
  }
  return { dsn, hasValidationIssue };
}
function isGokollab() {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  if (window && (((_b = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.host) == null ? void 0 : _b.endsWith("gokollab.com")) || ((_d = (_c = window == null ? void 0 : window.location) == null ? void 0 : _c.host) == null ? void 0 : _d.endsWith("localhost:6000"))) || ((_f = (_e = window == null ? void 0 : window.location) == null ? void 0 : _e.host) == null ? void 0 : _f.endsWith("localhost:3031")) || ((_h = (_g = window == null ? void 0 : window.location) == null ? void 0 : _g.host) == null ? void 0 : _h.endsWith("localhost:3032"))) {
    AppState.state.isGokollab = true;
    return true;
  }
  AppState.state.isGokollab = false;
  return false;
}
function isGokollabMobile() {
  var _a, _b;
  if (window && ((_b = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.host) == null ? void 0 : _b.endsWith("m.gokollab.com"))) {
    return true;
  }
  return false;
}
async function checkUserConsent(data) {
  var _a;
  try {
    window.localStorage.setItem("cat", window.btoa(JSON.stringify(data)));
    await UserState.getUserDetails();
    api.remove("cat");
    window.localStorage.removeItem("cat");
    if ((_a = UserState.state) == null ? void 0 : _a.termsConsent) {
      return true;
    }
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
}
function isAuthV2Enabled() {
  try {
    return isGokollab();
  } catch (error) {
    console.error(error);
    return false;
  }
}
function getSessionCookieData() {
  if (isAuthV2Enabled()) {
    const cookieValue = api.get("catv2") || window.localStorage.getItem("catv2");
    if (cookieValue) {
      const cookie = cookieValue ? JSON.parse(window.atob(cookieValue)) : null;
      return cookie;
    }
  } else {
    const cookieValue = api.get("cat") || window.localStorage.getItem("cat");
    if (cookieValue) {
      const cookie = cookieValue ? JSON.parse(window.atob(cookieValue)) : null;
      return cookie;
    }
  }
  return null;
}
function getSessionContactId() {
  const cookie = getSessionCookieData();
  return cookie == null ? void 0 : cookie.contactId;
}
function getSessionCookies() {
  if (isGokollab()) {
    return api.get("catv2");
  } else {
    return api.get("cat");
  }
}
function getSessionLocationId() {
  var _a;
  try {
    const cookieValue = api.get("cat") || window.localStorage.getItem("cat");
    if (cookieValue) {
      const cookie = cookieValue ? JSON.parse(window.atob(cookieValue)) : null;
      if (cookie == null ? void 0 : cookie.token) {
        try {
          const decodedToken = jwtDecode(cookie.token);
          return (_a = decodedToken == null ? void 0 : decodedToken.claims) == null ? void 0 : _a.locationId;
        } catch (decodeError) {
          console.error("Error decoding JWT token:", decodeError);
          return null;
        }
      }
    }
    return null;
  } catch (error) {
    console.error("Error getting location id from cat token", error);
    return null;
  }
}
function getSessionUserId() {
  var _a;
  try {
    const cookieValue = api.get("cat") || window.localStorage.getItem("cat");
    if (cookieValue) {
      const cookie = cookieValue ? JSON.parse(window.atob(cookieValue)) : null;
      if (cookie == null ? void 0 : cookie.token) {
        try {
          const decodedToken = jwtDecode(cookie.token);
          return (_a = decodedToken == null ? void 0 : decodedToken.claims) == null ? void 0 : _a.user_id;
        } catch (decodeError) {
          console.error("Error decoding JWT token:", decodeError);
          return null;
        }
      }
    }
    return null;
  } catch (error) {
    console.error("Error getting user id from cat token", error);
    return null;
  }
}
function getSessionApiKey() {
  var _a;
  try {
    const cookieValue = api.get("cat") || window.localStorage.getItem("cat");
    if (cookieValue) {
      const cookie = cookieValue ? JSON.parse(window.atob(cookieValue)) : null;
      if (cookie == null ? void 0 : cookie.token) {
        try {
          const decodedToken = jwtDecode(cookie.token);
          return (_a = decodedToken == null ? void 0 : decodedToken.claims) == null ? void 0 : _a.apiKey;
        } catch (decodeError) {
          console.error("Error decoding JWT token:", decodeError);
          return null;
        }
      }
    }
    return null;
  } catch (error) {
    console.error("Error getting user id from cat token", error);
    return null;
  }
}
const ES_INDEX_PREFIX = "client-portal";
const ES_INDEXES = {
  PUSH_NOTIFICATION_EVENT: "push-notification-event",
  INITIALIZE_PUSH_EVENT: "initialize-push-event"
};
var ES_STATUSES = /* @__PURE__ */ ((ES_STATUSES2) => {
  ES_STATUSES2["SUCCESS"] = "success";
  ES_STATUSES2["ERROR"] = "error";
  ES_STATUSES2["SKIPPED"] = "skipped";
  ES_STATUSES2["FAILED"] = "failed";
  return ES_STATUSES2;
})(ES_STATUSES || {});
var ES_LOG_LEVELS = /* @__PURE__ */ ((ES_LOG_LEVELS2) => {
  ES_LOG_LEVELS2["INFO"] = "info";
  ES_LOG_LEVELS2["WARN"] = "warn";
  ES_LOG_LEVELS2["ERROR"] = "error";
  return ES_LOG_LEVELS2;
})(ES_LOG_LEVELS || {});
var ES_PUSH_ACTION = /* @__PURE__ */ ((ES_PUSH_ACTION2) => {
  ES_PUSH_ACTION2["SENT"] = "sent";
  ES_PUSH_ACTION2["CLICKED"] = "clicked";
  return ES_PUSH_ACTION2;
})(ES_PUSH_ACTION || {});
const AnalyticsService = {
  trackEvent: (trackEvent) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/communities/analytics/track-event`,
      trackEvent
    );
  },
  trackEventV2: (payload) => {
    try {
      const { indexName, locationId, contactId, eventData, status, logLevel } = payload;
      const eventName = `${ES_INDEX_PREFIX}-${indexName}-`;
      const trackEvent = {
        eventName,
        locationId,
        contactId,
        eventData: {
          status,
          logLevel,
          ...eventData
        }
      };
      return requests().post(
        `${AppState.getConfig().REST_API_URLS}/communities/analytics/track-event`,
        trackEvent
      );
    } catch (error) {
      console.error(`Error sending data to ES:`, error);
    }
  },
  trackPageViewEvents: async (payload) => {
    try {
      return await requests().post(
        `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users-analytics/track/pendo`,
        payload
      );
    } catch (error) {
      console.error(
        `Analytics tracking failed for ${payload.eventType}:`,
        error
      );
      return Promise.resolve();
    }
  },
  trackPendoEvents: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users-analytics/track/pendo-events`,
      payload
    );
  }
};
const AuthServiceV2 = {
  signUp: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/signup`,
    {
      email: payload.email,
      password: payload.password,
      fullName: payload.username,
      locationId: payload.locationId,
      otp: payload.otp || null,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: isMobileTablet() ? "mobile" : "desktop",
      domainName: `${window.location.host}`,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      captchaToken: payload.captchaToken,
      referredBy: payload == null ? void 0 : payload.referredBy,
      signupPageUrl: (payload == null ? void 0 : payload.signupPageUrl) || null
    }
  ),
  loginWithEmailPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/login/email`,
    {
      email: payload.email,
      password: payload.password,
      userId: payload.userId || "",
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: isMobileTablet() ? "mobile" : "desktop",
      domainName: `${window.location.host}`,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      captchaToken: payload.captchaToken
    }
  ),
  loginWithSecureCode: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/login/otp`,
    {
      email: payload.email,
      otp: payload.otp || null,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: isMobileTablet() ? "mobile" : "desktop",
      domainName: `${window.location.host}`,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      action: (payload == null ? void 0 : payload.action) || null,
      fullName: (payload == null ? void 0 : payload.fullName) || null,
      captchaToken: payload.captchaToken
    }
  ),
  sendOtp: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/otps/${payload.locationId}/send`,
    {
      email: payload.email,
      fullName: payload.fullName,
      locationId: payload.locationId,
      captchaToken: payload.captchaToken,
      action: payload.action
    }
  ),
  loginWithLoginCode: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/login/loginCode`,
      {
        email: payload.email,
        loginCode: payload.loginCode,
        deviceName: navigator.userAgent,
        deviceId,
        deviceType: isMobileTablet() ? "mobile" : "desktop",
        domainName: payload.domainName,
        locationId: payload.locationId,
        ipAddress: "0.0.0.1",
        //not required
        redirectUrl: payload.redirectUrl || null
      }
    );
  },
  loginWithMagicLink: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/login/magic-link-token`,
      {
        email: payload.email,
        token: payload.token,
        deviceName: navigator.userAgent,
        deviceId,
        deviceType: isMobileTablet() ? "mobile" : "desktop",
        domainName: payload.domainName,
        locationId: payload.locationId,
        ipAddress: "0.0.0.1",
        //not required
        redirectUrl: payload.redirectUrl || null
      }
    );
  },
  changePassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/change-password`,
    {
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword
    }
  ),
  setPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/set-password`,
    {
      passwordResetToken: payload.passwordResetToken,
      contactId: payload.contactId,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword,
      captchaToken: payload.captchaToken
    }
  ),
  //reset password APIS
  resetPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/reset-password`,
    {
      userId: payload.userId,
      token: payload.token,
      password: payload.password,
      locationId: payload.locationId,
      isPwa: isPwa()
    }
  ),
  forgotPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/forgot-password`,
    {
      locationId: payload.locationId,
      email: payload.email,
      userId: payload.userId || "",
      captchaToken: payload.captchaToken
    }
  ),
  validateResetLink: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/validate-link`,
    {
      token: payload.token,
      userId: payload.userId,
      locationId: payload.locationId
    }
  ),
  loginWithSocialID: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/login/socialLogin`,
      {
        email: payload.email,
        idToken: payload.idToken,
        userId: payload.userId,
        authProvider: payload.authProvider,
        fullName: payload.fullName,
        deviceName: navigator.userAgent,
        deviceId,
        deviceType: isMobileTablet() ? "mobile" : "desktop",
        domainName: payload.domainName,
        locationId: payload.locationId,
        ipAddress: "0.0.0.1",
        //not required
        redirectUrl: payload.redirectUrl || null,
        referredBy: payload == null ? void 0 : payload.referredBy,
        signupPageUrl: (payload == null ? void 0 : payload.signupPageUrl) || null
      }
    );
  },
  updateSession: (payload, sessionUniqueId) => {
    return requests().patch(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/session/${sessionUniqueId}`,
      {
        loggedIn: payload.loggedIn,
        pushToken: payload.token,
        brandedAppId: payload.brandedAppId
      }
    );
  },
  registerPushToken: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/register-push-token`,
      {
        pushToken: payload.token,
        brandedAppId: payload.brandedAppId,
        sessionId: payload.sessionId,
        deviceType: getDevicePlatform(),
        releaseVersionCode: payload == null ? void 0 : payload.releaseVersionCode,
        appType: AppState.state.appType
      }
    );
  },
  refreshToken: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/refresh-token`,
      {
        refreshToken: payload.refreshToken
      }
    );
  },
  checkEmailExists: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/auth/login/check-email`,
      {
        email: payload.email,
        locationId: payload.locationId
      }
    );
  }
};
const UserService = {
  refreshFirebaseToken: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/auth/refresh-token`,
    {},
    {
      headers: {
        token: `${payload.token}`,
        "x-location-id": `${payload.locationId}`,
        "x-contact-id": `${payload.contactId}`,
        "x-platform": `${payload.platform}`,
        "x-auth-state": `${payload.authState}`,
        "x-middleware": "cp-core",
        "x-request-source": AppState.state.APP_NAME,
        "x-cp-build-version": "3.2.39",
        "x-retry-attempt": `${payload.retryAttempt || 0}`,
        "x-token-expiration-time": `${payload.tokenExpirationTime || ""}`
      }
    }
  ),
  signUp: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users`,
    {
      email: payload.email,
      password: payload.password,
      fullName: payload.username,
      locationId: payload.locationId,
      userId: payload.userId || "",
      token: payload.token || "",
      otp: payload.otp || null,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: getDevicePlatform(),
      releaseVersionCode: AppState.state.nativeReleaseVersionCode,
      appType: AppState.state.appType,
      domainName: `${window.location.host}`,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      captchaToken: payload.captchaToken
    }
  ),
  login: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/email`,
    {
      email: payload.email,
      password: payload.password,
      userId: payload.userId || "",
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: getDevicePlatform(),
      releaseVersionCode: AppState.state.nativeReleaseVersionCode,
      appType: AppState.state.appType,
      domainName: `${window.location.host}`,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      captchaToken: payload.captchaToken
    }
  ),
  portalSetting: (domain) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/portal-settings?domain=${domain}`
  ),
  initializePortalSettings: (locationId) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/portal-settings/initialize-app?locationId=${locationId}`
  ),
  loginWithSecureEmail: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/otp`,
    {
      email: payload.email,
      userId: payload.userId || "",
      token: payload.token || "",
      otp: payload.otp || null,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: getDevicePlatform(),
      releaseVersionCode: AppState.state.nativeReleaseVersionCode,
      appType: AppState.state.appType,
      domainName: `${window.location.host}`,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      //not required
      redirectUrl: payload.redirectUrl || null,
      action: (payload == null ? void 0 : payload.action) || null,
      fullName: (payload == null ? void 0 : payload.fullName) || null,
      captchaToken: payload.captchaToken
    }
  ),
  loginWithLoginCode: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/loginCode`,
      {
        email: payload.email,
        loginCode: payload.loginCode,
        deviceName: navigator.userAgent,
        deviceId,
        deviceType: getDevicePlatform(),
        releaseVersionCode: AppState.state.nativeReleaseVersionCode,
        appType: AppState.state.appType,
        domainName: payload.domainName,
        locationId: payload.locationId,
        ipAddress: "0.0.0.1",
        //not required
        redirectUrl: payload.redirectUrl || null
      }
    );
  },
  changePassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/change-password/${payload.contactId}`,
    {
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword
    }
  ),
  setPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/set-password`,
    {
      passwordResetToken: payload.passwordResetToken,
      contactId: payload.contactId,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword,
      captchaToken: payload.captchaToken
    }
  ),
  //reset password APIS
  resetPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/reset-password`,
    {
      userId: payload.userId,
      token: payload.token,
      password: payload.password,
      locationId: payload.locationId,
      isPwa: isPwa()
    }
  ),
  forgotPassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/forgot-password`,
    {
      locationId: payload.locationId,
      email: payload.email,
      userId: payload.userId || "",
      captchaToken: payload.captchaToken
    }
  ),
  validateResetLink: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/validate-link`,
    {
      token: payload.token,
      userId: payload.userId,
      locationId: payload.locationId
    }
  ),
  updateUser: async (payload) => {
    const response = await requests().put(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/${payload.userId}`,
      {
        email: payload.email,
        fullName: payload.fullName,
        termsConsent: payload.termsConsent,
        title: payload.title,
        bio: payload.bio,
        avatar: payload.avatar,
        profileCover: payload.profileCover,
        languagePreference: payload.languagePreference,
        timeZone: payload.timeZone,
        password: payload.password,
        newPassword: payload.newPassword,
        confirmPassword: payload.confirmPassword,
        location: payload.location,
        socials: payload.socials
      }
    );
    return response.data;
  },
  updateUserSlug: async (locationId, slug) => {
    const response = await requests().patch(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${locationId}/users/slug`,
      {
        slug
      }
    );
    return response.data;
  },
  loginWithSocialID: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/socialLogin`,
      {
        email: payload.email,
        idToken: payload.idToken,
        userId: payload.userId,
        authProvider: payload.authProvider,
        fullName: payload.fullName,
        deviceName: navigator.userAgent,
        deviceId,
        deviceType: getDevicePlatform(),
        releaseVersionCode: AppState.state.nativeReleaseVersionCode,
        appType: AppState.state.appType,
        domainName: payload.domainName,
        locationId: payload.locationId,
        ipAddress: "0.0.0.1",
        //not required
        redirectUrl: payload.redirectUrl || null
      }
    );
  },
  fetchUserDetails: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/${payload.userId}`
  ),
  getUserAnalytics: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users-analytics/${payload.contactId}`
  ),
  getUserDomains: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/na/users/domains`,
    {
      email: payload.email
    }
  ),
  updateSession: (payload) => {
    return requests().put(
      `${AppState.getConfig().REST_API_URLS}/clientclub/auth/session`,
      {
        loggedIn: payload.loggedIn,
        pushToken: payload.token,
        brandedAppId: payload.brandedAppId
      }
    );
  },
  registerPushToken: (payload) => {
    return requests().post(
      `${AppState.getConfig().REST_API_URLS}/clientclub/auth/register-push-token`,
      {
        pushToken: payload.token,
        brandedAppId: payload.brandedAppId,
        deviceType: getDevicePlatform(),
        releaseVersionCode: payload == null ? void 0 : payload.releaseVersionCode,
        appType: AppState.state.appType
      }
    );
  },
  getContactDetails: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/contact/${payload.contactId}`
  ),
  coursesActivityData: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/membership/locations/${payload.locationId}/products/user-activity/${payload.contactId}`
  ),
  getRecentlyVisitedGroups: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/communities/${payload.locationId}/users/groups`,
    {
      params: {
        contactId: payload.contactId,
        sort: "descending",
        sortKey: "lastVisitedAt",
        limit: (payload == null ? void 0 : payload.limit) || 0
      }
    }
  ),
  getChatWidgetConfig: async (locationId) => {
    var _a, _b;
    const chatWidgetId = (_b = (_a = LocationState == null ? void 0 : LocationState.state) == null ? void 0 : _a.chatWidgetSettings) == null ? void 0 : _b.widgetId;
    const response = await requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${locationId}/users/chat-widget`,
      {
        params: {
          widgetId: chatWidgetId,
          isGTM: false
        }
      }
    );
    return response.data;
  },
  getContracts: (payload) => {
    if (isGokollab()) {
      return UserServiceGokollab.getContracts(payload);
    }
    return requests().get(
      `${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users-analytics/proposals/${payload.contactId}`,
      {
        params: {
          limit: (payload == null ? void 0 : payload.limit) || 5,
          offset: (payload == null ? void 0 : payload.offset) || 0
        }
      }
    );
  },
  downloadContractPdf: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/proposals/document/public/download`,
    {
      params: payload
    }
  ),
  downloadEstimatePdf: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/invoices/estimate/download`,
    {
      estimateId: payload.estimateId,
      altId: payload.locationId,
      altType: "location"
    }
  )
};
const UserServiceGokollab = {
  getContracts: (payload) => requests().get(
    `${AppState.getConfig().GOKOLLAB_SERVER_URL}/clientclub/${payload.locationId}/users-analytics/proposals/${payload.contactId}`,
    {
      params: {
        limit: (payload == null ? void 0 : payload.limit) || 5,
        offset: (payload == null ? void 0 : payload.offset) || 0
      }
    }
  )
};
const currentFavicon = useFavicon();
const routerInstance = AppState.getRouterInstance();
const page = JSON.parse(localStorage.getItem("event"));
class LocationsState {
  constructor() {
    __publicField(this, "state", reactive({
      locationData: {},
      locationId: "",
      currencySymbol: "",
      subDomain: "",
      customDomain: "",
      languagePreferenceBuilder: "",
      branding: {
        brandColor2: null,
        brandColor1: null,
        portalBannerText: null,
        portalDescription: null,
        portalBackgroundImage: null,
        portalBannerImage: null,
        logo: null,
        portalIcon: null,
        favicon: null,
        copyRight: null,
        supportEmail: null
      },
      chatWidgetSettings: {
        widgetId: "",
        permissions: {
          communities: true,
          membership: true,
          home: true,
          affiliate: true
        }
      },
      locationPermissions: {
        membershipEnabled: true,
        affiliateManagerEnabled: true,
        communitiesEnabled: true,
        subscriptionsEnabled: true,
        contractsEnabled: true,
        estimatesEnabled: true,
        sharedFilesEnabled: true,
        certificatesEnabled: true
      }
    }));
  }
  async getBrandingDetails() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    try {
      if (window.location.hostname.includes(
        (_a = AppState == null ? void 0 : AppState.getConfig()) == null ? void 0 : _a.certificatesRegistryDomain
      )) {
        return;
      }
      let domain = (page == null ? void 0 : page.domain) || window.location.hostname;
      if (domain === "localhost") {
        const urlParams = new URLSearchParams(window.location.search);
        const domainname = urlParams.get("domain");
        domain = domainname || AppState.getConfig().domain;
      }
      if (!domain)
        throw Error("Domain not found, please setup in config for local setup");
      let portalSettingData;
      try {
        const locationId = getSessionLocationId();
        if (isPwa() && locationId) {
          portalSettingData = await initializePortalSettings(locationId);
        } else {
          portalSettingData = await fetchPortalSetting(domain);
        }
      } catch (error) {
        console.error("Error fetching portal settings:", error);
        return;
      }
      if (portalSettingData == null ? void 0 : portalSettingData.locationId) {
        this.state.locationData = isGokollab() ? this.getGokollabPortalSettingsData() : portalSettingData;
        this.state.locationId = portalSettingData.locationId;
      }
      if ((_b = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _b.favicon) {
        currentFavicon.value = (_c = portalSettingData.branding) == null ? void 0 : _c.favicon;
      }
      if (portalSettingData == null ? void 0 : portalSettingData.portalBannerText) {
        window.document.title = portalSettingData == null ? void 0 : portalSettingData.portalBannerText;
      }
      if (portalSettingData == null ? void 0 : portalSettingData.currencySymbol) {
        this.state.currencySymbol = portalSettingData.currencySymbol;
      }
      if (portalSettingData == null ? void 0 : portalSettingData.subDomain) {
        this.state.subDomain = portalSettingData.subDomain;
      }
      if (portalSettingData == null ? void 0 : portalSettingData.customDomain) {
        this.state.customDomain = portalSettingData.customDomain;
      }
      if (portalSettingData == null ? void 0 : portalSettingData.languagePreferenceBuilder) {
        this.state.languagePreferenceBuilder = portalSettingData.languagePreferenceBuilder;
      }
      this.setBrandingValue({
        brandColor1: ((_d = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _d.brandColor1) || null,
        brandColor2: ((_e = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _e.brandColor2) || null,
        portalBannerText: (portalSettingData == null ? void 0 : portalSettingData.portalBannerText) || null,
        portalDescription: (portalSettingData == null ? void 0 : portalSettingData.portalDescription) || null,
        portalIcon: (_f = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _f.logo,
        favicon: (_g = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _g.favicon,
        copyRight: portalSettingData == null ? void 0 : portalSettingData.copyRight,
        supportEmail: portalSettingData == null ? void 0 : portalSettingData.supportEmail,
        portalBackgroundImage: ((_h = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _h.portalImage) || null,
        portalBannerImage: ((_i = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _i.bannerImage) || null,
        logo: ((_j = portalSettingData == null ? void 0 : portalSettingData.branding) == null ? void 0 : _j.logo) || null
      });
      this.setPermissions(portalSettingData);
      this.setChatWidgetSettings(portalSettingData.chatWidgetSettings);
      if (routerInstance) {
        routerInstance.push({ name: "notFound" });
      }
    } catch (error) {
      console.error(error);
      if (!this.state.locationId) {
        if (routerInstance) {
          routerInstance.push({ name: "notFound" });
        }
      } else {
        if (routerInstance) {
          routerInstance.push({ name: "Login" });
        }
      }
    }
  }
  setBrandingValue(value) {
    this.state.branding.portalBannerText = value.portalBannerText;
    this.state.branding.portalDescription = value.portalDescription;
    this.state.branding.brandColor1 = value.brandColor1;
    this.state.branding.brandColor2 = value.brandColor2;
    this.state.branding.portalIcon = value.portalIcon;
    this.state.branding.favicon = value.favicon;
    this.state.branding.copyRight = value.copyRight;
    this.state.branding.supportEmail = value.supportEmail;
    this.state.branding.portalBackgroundImage = value.portalBackgroundImage;
    this.state.branding.portalBannerImage = value == null ? void 0 : value.portalBannerImage;
    this.state.branding.logo = value.logo;
  }
  setChatWidgetSettings(chatWidgetSettings) {
    var _a, _b, _c, _d;
    if (chatWidgetSettings == null ? void 0 : chatWidgetSettings.widgetId) {
      this.state.chatWidgetSettings.widgetId = chatWidgetSettings.widgetId;
    }
    if (chatWidgetSettings == null ? void 0 : chatWidgetSettings.permissions) {
      this.state.chatWidgetSettings.permissions.communities = (_a = chatWidgetSettings.permissions) == null ? void 0 : _a.communities;
      this.state.chatWidgetSettings.permissions.membership = (_b = chatWidgetSettings.permissions) == null ? void 0 : _b.membership;
      this.state.chatWidgetSettings.permissions.home = (_c = chatWidgetSettings.permissions) == null ? void 0 : _c.home;
      this.state.chatWidgetSettings.permissions.affiliate = (_d = chatWidgetSettings.permissions) == null ? void 0 : _d.affiliate;
    }
  }
  setPermissions(payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    this.state.locationPermissions.membershipEnabled = (_a = payload.locationPermissions) == null ? void 0 : _a.membershipEnabled;
    this.state.locationPermissions.affiliateManagerEnabled = (_b = payload.locationPermissions) == null ? void 0 : _b.affiliateManagerEnabled;
    this.state.locationPermissions.communitiesEnabled = (_c = payload.locationPermissions) == null ? void 0 : _c.communitiesEnabled;
    this.state.locationPermissions.subscriptionsEnabled = (_d = payload.locationPermissions) == null ? void 0 : _d.subscriptionsEnabled;
    this.state.locationPermissions.contractsEnabled = (_e = payload.locationPermissions) == null ? void 0 : _e.contractsEnabled;
    this.state.locationPermissions.estimatesEnabled = (_f = payload.locationPermissions) == null ? void 0 : _f.estimatesEnabled;
    this.state.locationPermissions.sharedFilesEnabled = (_g = payload.locationPermissions) == null ? void 0 : _g.sharedFilesEnabled;
    this.state.locationPermissions.certificatesEnabled = (_h = payload.locationPermissions) == null ? void 0 : _h.certificatesEnabled;
  }
  getGokollabPortalSettingsData() {
    return {
      _id: AppState.getConfig().GOKOLLAB_LOCATION_ID,
      locationId: AppState.getConfig().GOKOLLAB_LOCATION_ID,
      branding: {
        brandColor1: ""
      }
    };
  }
}
const getHostName = () => {
  var _a, _b, _c, _d, _e;
  if (isGokollab()) {
    return AppState.state.NODE_ENV === "production" ? "gokollab.com" : "staging.gokollab.com";
  }
  if (((_a = LocationState.state) == null ? void 0 : _a.subDomain) || ((_b = LocationState.state) == null ? void 0 : _b.customDomain) && isPwa()) {
    const suffixDomain = AppState.state.NODE_ENV === "production" ? ".app" : ".staging";
    return ((_c = LocationState.state) == null ? void 0 : _c.customDomain) ? (_d = LocationState.state) == null ? void 0 : _d.customDomain : ((_e = LocationState.state) == null ? void 0 : _e.subDomain) + suffixDomain + ".clientclub.net";
  } else {
    return window.location.hostname;
  }
};
const getLocationId = () => {
  return LocationState.state.locationId;
};
async function fetchPortalSetting(domain) {
  const portalSetting = isGokollab() ? gokollabStubData() : await UserService.portalSetting(domain);
  return portalSetting.data;
}
async function initializePortalSettings(locationId) {
  const portalSetting = isGokollab() ? gokollabStubData() : await UserService.initializePortalSettings(locationId);
  return portalSetting.data;
}
function getGokollabLocationId() {
  return AppState.getConfig().GOKOLLAB_LOCATION_ID;
}
function getLocationData() {
  return { ...LocationState.state };
}
function gokollabStubData() {
  return {
    data: {
      locationId: AppState.getConfig().GOKOLLAB_LOCATION_ID,
      currencySymbol: "₹",
      subDomain: "gokollab",
      customDomain: "",
      branding: {
        brandColor2: null,
        brandColor1: null,
        portalBannerText: "Gokollab",
        portalDescription: "Gokollab",
        portalBackgroundImage: null,
        portalBannerImage: null,
        logo: null,
        portalIcon: null,
        favicon: null
      },
      locationPermissions: {
        membershipEnabled: false,
        affiliateManagerEnabled: false,
        communitiesEnabled: false,
        subscriptionsEnabled: false,
        contractsEnabled: false,
        estimatesEnabled: false,
        sharedFilesEnabled: false
      }
    }
  };
}
const LocationState = new LocationsState();
const CommunitiesService = {
  async getUsersGroup(locationId) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).get(`${locationId}/users/groups`);
    return response.data;
  },
  async toggleChatPreference(locationId, groupId, body) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).post(`${locationId}/groups/${groupId}/update-chat-preference`, body);
    return response.data;
  },
  async getBlockedUsers(locationId, paginationParams) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).get(`${locationId}/conversations/blocked`, {
      params: paginationParams
    });
    return response.data;
  },
  async unblockConversation(locationId, conversationId) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).post(`${locationId}/conversations/${conversationId}/unblock`);
    return response.data;
  },
  async pinGroup(locationId, groupId) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).post(`${locationId}/groups/${groupId}/pin`);
    return response.data;
  },
  async unpinGroup(locationId, groupId) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).post(`${locationId}/groups/${groupId}/unpin`);
    return response.data;
  },
  async getGroups(locationId) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).get(`${locationId}/groups`);
    return response.data;
  },
  async getPinnedGroups(locationId) {
    const response = await requests(
      AppState.getConfig().COMMUNITIES_API_URL
    ).get(`${locationId}/groups/pinned`);
    return response.data;
  }
};
function formatDateDay(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear() % 100;
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  return `${day} ${months[month]} ${year}`;
}
function convertToRelativeTime(isoDate) {
  const currentDate = /* @__PURE__ */ new Date();
  const givenDate = new Date(isoDate);
  const timeDifference = currentDate.getTime() - givenDate.getTime();
  const seconds = timeDifference / 1e3;
  const intervals = [
    ["y", 31536e3],
    // seconds in a year
    ["mo", 2592e3],
    // seconds in a month
    ["w", 604800],
    // seconds in a week
    ["d", 86400],
    // seconds in a day
    ["h", 3600],
    // seconds in an hour
    ["m", 60],
    // seconds in a minute
    ["s", 1]
    // seconds
  ];
  let output = "";
  for (const [intervalName, intervalSeconds] of intervals) {
    if (seconds < 1) {
      output = "Just now";
      break;
    }
    if (seconds >= intervalSeconds) {
      const intervalValue = Math.floor(seconds / intervalSeconds);
      output += `${intervalValue}${intervalName} ago`;
      break;
    }
  }
  return output;
}
function formatDate(dateString) {
  const timeZone = "UTC";
  const zonedDate = toZonedTime(dateString, timeZone);
  return format(zonedDate, "dd/MM/yyyy", { timeZone });
}
const CoursesService = {
  async pinCourse(locationId, courseId) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).post(`/membership/locations/${locationId}/products/${courseId}/pin`);
    return response.data;
  },
  async unpinCourse(locationId, courseId) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).post(`/membership/locations/${locationId}/products/${courseId}/unpin`);
    return response.data;
  },
  async getCourses(locationId) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).get(`/membership/locations/${locationId}/user-purchase/get-all-products`);
    return response.data;
  },
  async getPinnedCourses(locationId) {
    const response = await requests(
      AppState.getConfig().REST_API_URLS
    ).get(`/membership/locations/${locationId}/products/pinned`);
    return response.data;
  }
};
let MediaService$1 = class MediaService {
  constructor(locationId) {
    __publicField(this, "subdomain", "");
    __publicField(this, "locationId", "");
    this.locationId = locationId;
    this.subdomain = `${locationId}/medias`;
  }
  async generateSignedUrl(data) {
    var _a;
    return requests((_a = AppState == null ? void 0 : AppState.getConfig()) == null ? void 0 : _a.INTERNAL_URL).post(
      `${this.subdomain}/signed-url`,
      data
    );
  }
  async compressImage(imageCloudUrl, resolution) {
    var _a;
    return requests((_a = AppState == null ? void 0 : AppState.getConfig()) == null ? void 0 : _a.INTERNAL_URL).post(
      `${this.subdomain}/compress-image`,
      {
        imageUrl: imageCloudUrl,
        resolution
      }
    );
  }
};
let NotificationsService$1 = class NotificationsService {
  constructor() {
    __publicField(this, "basePath", "");
  }
  async getNotifications(read, paginationObject) {
    const url = isAuthV2Enabled() ? `${this.basePath}/notifications/v2` : `${this.basePath}/notifications`;
    const response = await requests(
      AppState.getConfig().INTERNAL_URL
    ).get(url, {
      params: { read, ...paginationObject }
    });
    return response == null ? void 0 : response.data;
  }
  async markNotificationAsRead(notificationId, refId) {
    let params = {};
    if (notificationId) {
      params = { notificationId };
    } else if (refId) {
      params = { refId };
    }
    const url = isAuthV2Enabled() ? `${this.basePath}/notifications/v2/read` : `${this.basePath}/notifications/read`;
    const response = await requests(
      AppState.getConfig().INTERNAL_URL
    ).post(url, null, {
      params
    });
    return response.data;
  }
};
let MediaService2;
function initializeServices(locationId) {
  MediaService2 = new MediaService$1(locationId);
}
async function setBadgeCount(count) {
  try {
    const { isSupported } = await Badge.isSupported();
    if (isSupported) {
      const { display } = await Badge.requestPermissions();
      if (display === "granted") {
        await Badge.set({
          count: Math.min(count, 99)
        });
      } else {
        console.error("Badge permissions not granted");
      }
    } else {
      console.error("Badge is not supported on this device");
    }
  } catch (error) {
    console.error("Error setting badge count:", error);
  }
}
async function trackAutoLogout(message, error) {
  var _a, _b;
  try {
    await AnalyticsService.trackEvent({
      eventName: "client-portal-user-auto-logout",
      locationId: getSessionLocationId() || "NA",
      groupId: "NA",
      contactId: getSessionUserId() || "NA",
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat"),
        platform: ((_a = getPlatformDetails()) == null ? void 0 : _a.platform) || "NA",
        href: ((_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href) || "NA",
        "x-request-source": AppState.state.APP_NAME,
        "x-cp-build-version": "3.2.39",
        message,
        error
      }
    });
  } catch (error2) {
    console.error("Error in trackEvent:", error2);
  }
}
async function trackGenerateTokenFailed(message, error, retryAttempt) {
  var _a, _b;
  try {
    await AnalyticsService.trackEvent({
      eventName: "generate-token-failed",
      locationId: getSessionLocationId() || "NA",
      groupId: "NA",
      contactId: getSessionUserId() || "NA",
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat"),
        platform: ((_a = getPlatformDetails()) == null ? void 0 : _a.platform) || "NA",
        href: ((_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href) || "NA",
        "x-request-source": AppState.state.APP_NAME,
        "x-cp-build-version": "3.2.39",
        message,
        error,
        retryAttempt: retryAttempt || "NA"
      }
    });
  } catch (error2) {
    console.error("Error in trackEvent:", error2);
  }
}
async function trackGenerateTokenSuccess(message, error) {
  var _a, _b;
  try {
    await AnalyticsService.trackEvent({
      eventName: "generate-token-success",
      locationId: getSessionLocationId() || "NA",
      groupId: "NA",
      contactId: getSessionUserId() || "NA",
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat"),
        platform: ((_a = getPlatformDetails()) == null ? void 0 : _a.platform) || "NA",
        href: ((_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href) || "NA",
        "x-request-source": AppState.state.APP_NAME,
        "x-cp-build-version": "3.2.39",
        message,
        error: error || "NA"
      }
    });
  } catch (error2) {
    console.error("Error in trackEvent:", error2);
  }
}
async function trackAutoLogoutFromCommunities(message, error) {
  var _a, _b;
  try {
    await AnalyticsService.trackEvent({
      eventName: "communities-user-auto-logout",
      locationId: getSessionLocationId() || "NA",
      groupId: "NA",
      contactId: getSessionUserId() || "NA",
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat"),
        platform: ((_a = getPlatformDetails()) == null ? void 0 : _a.platform) || "NA",
        href: ((_b = window == null ? void 0 : window.location) == null ? void 0 : _b.href) || "NA",
        "x-request-source": AppState.state.APP_NAME,
        "x-cp-build-version": "3.2.39",
        message,
        error
      }
    });
  } catch (error2) {
    console.error("Error in trackEvent:", error2);
  }
}
async function trackPushTokenAnalytics({ attempt, fcmToken }) {
  const { platform } = getPlatformDetails();
  const apiKey = getSessionApiKey();
  await AnalyticsService.trackEventV2({
    indexName: ES_INDEXES.INITIALIZE_PUSH_EVENT,
    locationId: LocationState.state.locationId,
    contactId: UserState.state.userId,
    status: ES_STATUSES.SUCCESS,
    logLevel: ES_LOG_LEVELS.INFO,
    eventData: {
      platform,
      attempt,
      fcmToken,
      apiKey
    }
  });
}
async function trackPendoEvents(payload) {
  try {
    if (!(payload == null ? void 0 : payload.locationId)) {
      payload.locationId = LocationState.state.locationId;
    }
    await AnalyticsService.trackPendoEvents(payload);
  } catch (error) {
    console.error("Error in trackPendoEvents:", error);
  }
}
function generateUniqueId() {
  return "force-update-" + Date.now() + "-" + Math.random().toString(36).substr(2, 9);
}
async function trackForceUpdateEvent(type) {
  var _a;
  try {
    const currentReleaseVersionCode = AppState.state.nativeReleaseVersionCode || "unknown";
    const existingData = localStorage.getItem(FORCE_UPDATE_TRACKING_KEY);
    let trackingData = null;
    if (existingData) {
      try {
        trackingData = JSON.parse(existingData);
      } catch (error) {
        console.error("Error parsing force update tracking data:", error);
      }
    }
    let uniqueId;
    if (!trackingData) {
      uniqueId = generateUniqueId();
      trackingData = {
        uniqueId,
        releaseVersionCode: currentReleaseVersionCode,
        timestamp: Date.now()
      };
      localStorage.setItem(FORCE_UPDATE_TRACKING_KEY, JSON.stringify(trackingData));
    } else {
      uniqueId = trackingData.uniqueId;
      if (trackingData.releaseVersionCode !== currentReleaseVersionCode) {
        trackingData.releaseVersionCode = currentReleaseVersionCode;
        trackingData.timestamp = Date.now();
        localStorage.setItem(FORCE_UPDATE_TRACKING_KEY, JSON.stringify(trackingData));
      }
    }
    const platform = ((_a = getPlatformDetails()) == null ? void 0 : _a.platform) || "NA";
    const appType = BrandedAppState.state.locationId ? "WL" : "GL";
    await AnalyticsService.trackEvent({
      eventName: "client-portal-force-app-update-event-",
      locationId: getSessionLocationId() || "NA",
      contactId: getSessionUserId() || "NA",
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat"),
        platform,
        "x-request-source": AppState.state.APP_NAME,
        "x-cp-build-version": "3.2.39",
        type,
        uniqueId,
        releaseVersionCode: currentReleaseVersionCode,
        previousReleaseVersionCode: trackingData ? trackingData.releaseVersionCode : "NA",
        appType,
        locationId: BrandedAppState.state.locationId,
        deviceName: navigator.userAgent,
        deviceId,
        deviceType: isMobileTablet() ? "mobile" : "desktop",
        domainName: `${window.location.host}`
      }
    });
  } catch (error) {
    console.error("Error in trackForceUpdateEventEnhanced:", error);
  }
}
function getTokenRefreshState() {
  const state = localStorage.getItem(FCM_TOKEN_REFRESH_STORAGE_KEY);
  return state ? JSON.parse(state) : null;
}
function setTokenRefreshState(state) {
  localStorage.setItem(FCM_TOKEN_REFRESH_STORAGE_KEY, JSON.stringify(state));
}
function clearTokenRefreshState() {
  localStorage.removeItem(FCM_TOKEN_REFRESH_STORAGE_KEY);
}
function isRefreshTimeExpired(timestamp) {
  return Date.now() - timestamp >= FCM_TOKEN_REFRESH_WAIT_TIME;
}
async function attemptTokenRegistration(fcmToken, attempt) {
  var _a, _b, _c, _d, _e;
  try {
    await trackPushTokenAnalytics({
      attempt: attempt + 1,
      fcmToken
    });
    const cookie = await getSessionCookieData();
    if (!(cookie == null ? void 0 : cookie.contactId)) {
      console.error("No contactId found - cannot register push token");
      return false;
    }
    const payload = {
      token: fcmToken,
      sessionId: cookie == null ? void 0 : cookie.sessionUniqueId,
      locationId: (_a = LocationState == null ? void 0 : LocationState.state) == null ? void 0 : _a.locationId,
      releaseVersionCode: (_b = AppState == null ? void 0 : AppState.state) == null ? void 0 : _b.nativeReleaseVersionCode
    };
    if (((_c = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _c.id) && Capacitor.getPlatform() === "ios") {
      payload["brandedAppId"] = (_d = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _d.id;
    }
    let registerResponse = null;
    if (isAuthV2Enabled()) {
      registerResponse = await AuthServiceV2.registerPushToken(payload).catch((e) => {
        console.error("Error in registerPushToken:", e);
        return null;
      });
    } else {
      registerResponse = await UserService.registerPushToken(payload).catch((e) => {
        console.error("Error in registerPushToken:", e);
        return null;
      });
    }
    if ((_e = registerResponse == null ? void 0 : registerResponse.data) == null ? void 0 : _e.success) {
      clearTokenRefreshState();
      return true;
    }
    return false;
  } catch (e) {
    console.error("Error in token registration attempt:", e);
    return false;
  }
}
function scheduleTokenRetry(fcmToken, attempt, maxRetries) {
  if (attempt >= maxRetries) {
    console.log("Max retries reached for token registration");
    clearTokenRefreshState();
    return;
  }
  setTokenRefreshState({
    status: TokenRefreshStatus.REFRESHING,
    timestamp: Date.now(),
    attempts: attempt + 1
  });
  FCM.refreshToken().then((result) => {
    const newToken = result == null ? void 0 : result.token;
    setTimeout(async () => {
      try {
        setTokenRefreshState({
          status: TokenRefreshStatus.PENDING_RETRY,
          timestamp: Date.now(),
          attempts: attempt + 1
        });
        const freshResult = await FCM.getToken();
        const freshToken = (freshResult == null ? void 0 : freshResult.token) || newToken;
        const success = await attemptTokenRegistration(freshToken, attempt + 1);
        if (!success) {
          scheduleTokenRetry(freshToken, attempt + 1, maxRetries);
        }
      } catch (e) {
        console.error("Error in scheduled token retry:", e);
        clearTokenRefreshState();
      }
    }, FCM_TOKEN_REFRESH_WAIT_TIME);
  }).catch((e) => {
    console.error("Error in token refresh:", e);
    clearTokenRefreshState();
  });
}
async function registerPushTokenWithRetry(initialToken, maxRetries) {
  try {
    const currentState = getTokenRefreshState();
    let currentToken = initialToken;
    if (currentState) {
      if (isRefreshTimeExpired(currentState.timestamp)) {
        currentState.status = TokenRefreshStatus.PENDING_RETRY;
        setTokenRefreshState(currentState);
        try {
          const result = await FCM.getToken();
          currentToken = result.token || currentToken;
        } catch (e) {
          console.error("Error getting fresh token from state:", e);
        }
      } else if (currentState.status === TokenRefreshStatus.REFRESHING) {
        const timeSinceRefresh = Date.now() - currentState.timestamp;
        const remainingTime = FCM_TOKEN_REFRESH_WAIT_TIME - timeSinceRefresh;
        if (remainingTime > 0) {
          console.log(`Recreating lost setTimeout with ${remainingTime}ms remaining`);
          setTimeout(async () => {
            try {
              setTokenRefreshState({
                status: TokenRefreshStatus.PENDING_RETRY,
                timestamp: Date.now(),
                attempts: currentState.attempts
              });
              const freshResult = await FCM.getToken();
              const freshToken = (freshResult == null ? void 0 : freshResult.token) || currentToken;
              const success2 = await attemptTokenRegistration(freshToken, currentState.attempts);
              if (!success2) {
                scheduleTokenRetry(freshToken, currentState.attempts, maxRetries);
              }
            } catch (e) {
              console.error("Error in recreated timeout retry:", e);
              clearTokenRefreshState();
            }
          }, remainingTime);
          return false;
        } else {
          try {
            const result = await FCM.getToken();
            currentToken = result.token || currentToken;
          } catch (e) {
            console.error("Error getting token for overdue retry:", e);
          }
        }
      }
    }
    const success = await attemptTokenRegistration(currentToken, 0);
    if (!success) {
      scheduleTokenRetry(currentToken, 0, maxRetries);
    }
    return success;
  } catch (e) {
    console.error("Error in registerPushTokenWithRetry:", e);
    clearTokenRefreshState();
    return false;
  }
}
async function deleteFCMToken() {
  try {
    if (Capacitor.isNativePlatform()) {
      if (FCM) {
        await FCM.refreshToken().catch((err) => console.error(err));
        await FCM.deleteInstance().catch((err) => console.error(err));
      }
      await PushNotifications.unregister();
      await PushNotifications.removeAllListeners();
    }
  } catch (error) {
    console.error("Error deleting FCM token", error);
  }
}
function setPushNotificationData(data) {
  try {
    api.set("pushNotificationData", window.btoa(JSON.stringify(data)), {
      expires: 2 / (24 * 60),
      // 2 minutes
      secure: true,
      sameSite: "None"
    });
  } catch (error) {
    console.error("Error storing push notification data in cookie:", error);
  }
}
function getPushNotificationData() {
  try {
    const cookieValue = api.get("pushNotificationData");
    if (cookieValue) {
      return JSON.parse(window.atob(cookieValue));
    }
  } catch (error) {
    console.error("Error retrieving push notification data from cookie:", error);
  }
  return null;
}
function removePushNotificationData() {
  try {
    api.remove("pushNotificationData");
  } catch (error) {
    console.error("Error removing push notification data from cookie:", error);
  }
}
function getPushNotificationRedirectPath() {
  var _a, _b, _c;
  try {
    const pushNotificationData = getPushNotificationData();
    if (!pushNotificationData) return null;
    const platform = Capacitor.getPlatform();
    return platform === CAPACITOR_PLATFORM.ANDROID ? (_a = pushNotificationData == null ? void 0 : pushNotificationData.detail) == null ? void 0 : _a.redirectPath : (_c = (_b = pushNotificationData == null ? void 0 : pushNotificationData.notification) == null ? void 0 : _b.data) == null ? void 0 : _c.redirectPath;
  } catch (error) {
    console.error(
      "Error retrieving push notification redirect path from cookie:",
      error
    );
  }
  return null;
}
const ReleaseVersionCode = registerPlugin("ReleaseVersionCode");
const getNativeReleaseVersionCode = async () => {
  try {
    if (!Capacitor.isNativePlatform()) {
      AppState.state.nativeReleaseVersionCode = null;
      return;
    }
    const res = await ReleaseVersionCode.getReleaseVersionCode();
    AppState.state.nativeReleaseVersionCode = res.releaseVersionCode;
    return res.releaseVersionCode;
  } catch (error) {
    console.error("Error getting release version code:", error);
    AppState.state.nativeReleaseVersionCode = null;
    return null;
  }
};
const getNativeAppVersion = async () => {
  try {
    if (!Capacitor.isNativePlatform()) {
      AppState.state.nativeAppVersion = null;
      return;
    }
    const appInfo = await App.getInfo();
    AppState.state.nativeAppVersion = appInfo.version;
    return appInfo.version;
  } catch (error) {
    console.error("Error getting app version:", error);
    AppState.state.nativeAppVersion = null;
    return null;
  }
};
async function checkVersionCompatibility(latestVersionCodes, minimumVersionCodes, playStoreAppLink, appStoreAppLink) {
  const result = {
    isForceUpdateRequired: false,
    isSoftUpdateRequired: false,
    currentVersionCode: -1,
    platformSpecificUpdateUrl: ""
  };
  try {
    if (!Capacitor.isNativePlatform()) {
      return result;
    }
    const platform = Capacitor.getPlatform();
    if (platform !== CAPACITOR_PLATFORM.ANDROID && platform !== CAPACITOR_PLATFORM.IOS) {
      return result;
    }
    result.platformSpecificUpdateUrl = platform === CAPACITOR_PLATFORM.ANDROID && playStoreAppLink ? playStoreAppLink : platform === CAPACITOR_PLATFORM.IOS && appStoreAppLink ? appStoreAppLink : "";
    const latestVersionNumber = latestVersionCodes[platform] ?? -1;
    const minimumVersionNumber = minimumVersionCodes[platform] ?? -1;
    try {
      const versionCodeResult = await ReleaseVersionCode.getReleaseVersionCode();
      if (!(versionCodeResult == null ? void 0 : versionCodeResult.releaseVersionCode) || versionCodeResult.releaseVersionCode === "NO_VERSION_FOUND") {
        throw new Error("Version code is not available");
      }
      const currentVersion = parseInt(versionCodeResult.releaseVersionCode, 10);
      result.currentVersionCode = currentVersion;
      if (latestVersionNumber >= minimumVersionNumber && currentVersion < minimumVersionNumber) {
        result.isForceUpdateRequired = true;
      } else if (currentVersion < latestVersionNumber) {
        result.isSoftUpdateRequired = true;
      }
    } catch (error) {
      if (latestVersionNumber >= minimumVersionNumber) {
        result.isForceUpdateRequired = true;
      } else {
        console.error(
          "Force update not allowed. Latest version is below the minimum required.",
          error
        );
      }
    }
    return result;
  } catch (error) {
    console.error("Error checking version compatibility", error);
    return result;
  }
}
const AppConfigService = {
  getAppVersions: () => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/app-versions`
  )
};
class AppVersionsState {
  constructor() {
    __publicField(this, "state", reactive({
      appStoreVersionCodes: {
        android: -1,
        ios: -1
      },
      minimumVersionCode: {
        android: -1,
        ios: -1
      },
      isForceUpdateRequired: false,
      isSoftUpdateRequired: false,
      currentVersionCode: -1,
      platformSpecificUpdateUrl: "",
      isGreyLabel: false
    }));
  }
  get isForceUpdateRequired() {
    return this.state.isForceUpdateRequired;
  }
  get isSoftUpdateRequired() {
    return this.state.isSoftUpdateRequired;
  }
  get platformSpecificUpdateUrl() {
    return this.state.platformSpecificUpdateUrl;
  }
  updateAppVersions(appStoreVersionCodes, minimumVersionCode) {
    if (appStoreVersionCodes) {
      this.state.appStoreVersionCodes = {
        android: appStoreVersionCodes.android ?? -1,
        ios: appStoreVersionCodes.ios ?? -1
      };
    }
    if (minimumVersionCode) {
      this.state.minimumVersionCode = {
        android: minimumVersionCode.android ?? -1,
        ios: minimumVersionCode.ios ?? -1
      };
    }
  }
  async checkAppVersionCompatibility(playStoreAppLink, appStoreAppLink) {
    try {
      const result = await checkVersionCompatibility(
        this.state.appStoreVersionCodes,
        this.state.minimumVersionCode,
        playStoreAppLink,
        appStoreAppLink
      );
      this.state.isForceUpdateRequired = result.isForceUpdateRequired;
      this.state.isSoftUpdateRequired = result.isSoftUpdateRequired;
      this.state.currentVersionCode = result.currentVersionCode;
      this.state.platformSpecificUpdateUrl = result.platformSpecificUpdateUrl || "";
      if (!result.isForceUpdateRequired) {
        const existingData = localStorage.getItem(FORCE_UPDATE_TRACKING_KEY);
        let trackingData = null;
        if (existingData) {
          try {
            trackingData = JSON.parse(existingData);
          } catch (error) {
            console.error("Error parsing force update tracking data:", error);
          }
        }
        if (trackingData && this.state.currentVersionCode > trackingData.releaseVersionCode) {
          await trackForceUpdateEvent(ForceUpdateEvents.FORCE_UPDATE_SUCCESSFUL);
        }
      }
      return result;
    } catch (error) {
      console.error("Error checking app version compatibility", error);
      return {
        isForceUpdateRequired: false,
        isSoftUpdateRequired: false,
        currentVersionCode: -1,
        platformSpecificUpdateUrl: ""
      };
    }
  }
  async fetchAppVersions() {
    try {
      this.state.isGreyLabel = true;
      const response = await AppConfigService.getAppVersions();
      const { greyLabel } = response.data || {};
      if (greyLabel) {
        if (greyLabel.appStoreVersion) {
          this.state.appStoreVersionCodes = {
            android: greyLabel.appStoreVersion.android ?? -1,
            ios: greyLabel.appStoreVersion.ios ?? -1
          };
        }
        if (greyLabel.minimumVersion) {
          this.state.minimumVersionCode = {
            android: greyLabel.minimumVersion.android ?? -1,
            ios: greyLabel.minimumVersion.ios ?? -1
          };
        }
      }
      await this.checkAppVersionCompatibility(
        GL_PLAY_STORE_LINK,
        GL_APP_STORE_LINK
      );
    } catch (error) {
      console.error("Error fetching app versions", error);
    }
  }
}
const AppVersionsInstance = new AppVersionsState();
const NotificationsService2 = new NotificationsService$1();
class NotificationsState {
  constructor() {
    __publicField(this, "state", reactive({
      isLoading: false,
      notifications: new Array(),
      isNextPageAvailable: true,
      unReadNotificationCount: 0
    }));
  }
  clearNotifications() {
    this.state.notifications = [];
    this.state.isNextPageAvailable = true;
  }
  async markNotificationAsRead(notificationId, refId) {
    try {
      await (NotificationsService2 == null ? void 0 : NotificationsService2.markNotificationAsRead(notificationId, refId));
      if (!notificationId && !refId) {
        this.state.notifications.forEach((n) => n.isRead = true);
        this.state.unReadNotificationCount = 0;
      } else {
        const notification = this.state.notifications.find(
          (n) => n._id === notificationId
        );
        if (notification) {
          notification.isRead = true;
        }
        if (this.state.unReadNotificationCount > 0) {
          this.state.unReadNotificationCount -= 1;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getNotifications(read, paginationObject) {
    try {
      if (!this.state.isNextPageAvailable) {
        return;
      }
      if (!(paginationObject == null ? void 0 : paginationObject.previousId) && this.state.notifications.length > 0) {
        return;
      } else {
        const previousIdIndex = this.state.notifications.findIndex(
          (notification) => notification._id === (paginationObject == null ? void 0 : paginationObject.previousId)
        );
        if (previousIdIndex != this.state.notifications.length - 1) {
          return;
        }
      }
      this.state.isLoading = true;
      const notifications = await (NotificationsService2 == null ? void 0 : NotificationsService2.getNotifications(
        read,
        paginationObject
      ));
      notifications == null ? void 0 : notifications.forEach((n) => {
        if (!this.state.notifications.find(
          (notification) => notification._id == n._id
        )) {
          n.relativeTime = convertToRelativeTime(n.createdAt);
          this.state.notifications.push(n);
        }
      });
      this.state.isLoading = false;
      if (paginationObject == null ? void 0 : paginationObject.limit) {
        if (((notifications == null ? void 0 : notifications.length) || 0) < paginationObject.limit) {
          this.state.isNextPageAvailable = false;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getUnreadNotificationsCount(limit = 21) {
    try {
      const notifications = await (NotificationsService2 == null ? void 0 : NotificationsService2.getNotifications(false, {
        limit
      }));
      this.state.unReadNotificationCount = (notifications == null ? void 0 : notifications.length) || 0;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
const NotificationState = new NotificationsState();
const getIsWhiteLabeledApp = async () => {
  try {
    if (!Capacitor.isNativePlatform()) {
      if (isGokollab()) {
        AppState.state.appType = "GL";
      } else {
        AppState.state.appType = "WL";
      }
      return;
    } else {
      const BrandedLocationPlugin = registerPlugin("BrandedLocation");
      const brandedLocationId = await BrandedLocationPlugin.getBrandedLocation();
      if (brandedLocationId == null ? void 0 : brandedLocationId.value) {
        AppState.state.appType = "WL";
      } else {
        AppState.state.appType = "GL";
      }
      return;
    }
  } catch (error) {
    console.error("Error checking if app is white-labeled:", error);
    AppState.state.appType = null;
    return;
  }
};
const VersionDisplay = defineAsyncComponent(
  () => import("./VersionDisplay-BmgQS7mp.js")
);
let firebaseAppInstance = null;
async function initializeApp(appName, app, environment, routerInstance2, sentryOptions, firebaseAppName) {
  var _a, _b, _c, _d, _e;
  try {
    AppState.state.NODE_ENV = environment;
    AppState.state.APP_NAME = appName;
    await Promise.all([
      getIsWhiteLabeledApp(),
      getNativeReleaseVersionCode(),
      getNativeAppVersion()
    ]);
    initSentry(app, {
      dsn: config[AppState.state.NODE_ENV].SENTRY_DSN,
      appName: Capacitor.isNativePlatform() ? ClientPortalApps.CLIENT_PORTAL_MOBILE : appName || ClientPortalApps.CLIENT_PORTAL,
      appTag: appName,
      router: routerInstance2,
      environment: AppState.state.NODE_ENV,
      sampleRate: sentryOptions == null ? void 0 : sentryOptions.sampleRate,
      tracesSampleRate: sentryOptions == null ? void 0 : sentryOptions.tracesSampleRate,
      replaysSessionSampleRate: Capacitor.isNativePlatform() ? sentryOptions == null ? void 0 : sentryOptions.replaysSessionSampleRate : 0,
      // enable only for mobile apps for now
      replaysOnErrorSampleRate: Capacitor.isNativePlatform() ? sentryOptions == null ? void 0 : sentryOptions.replaysOnErrorSampleRate : 0,
      // enable only for mobile apps for now
      profilesSampleRate: sentryOptions == null ? void 0 : sentryOptions.profilesSampleRate,
      release: sentryOptions == null ? void 0 : sentryOptions.release,
      ignoreErrors: [
        "Token generation failed after all retries",
        ...(sentryOptions == null ? void 0 : sentryOptions.ignoreErrors) || []
      ],
      beforeSend: sentryOptions == null ? void 0 : sentryOptions.beforeSend
    });
    if (firebaseAppName) {
      firebaseAppInstance = firebase.initializeApp(
        config[environment].firebase,
        firebaseAppName
      );
    } else {
      firebaseAppInstance = firebase.initializeApp(config[environment].firebase);
    }
    const auth = initializeAuth(firebaseAppInstance, {
      persistence: browserLocalPersistence
    });
    AppState.setFirebaseAuthInstance(auth);
    if (Capacitor.isNativePlatform()) {
      try {
        const BrandedLocationPlugin = registerPlugin("BrandedLocation");
        const brandedLocationId = await BrandedLocationPlugin.getBrandedLocation();
        if (brandedLocationId == null ? void 0 : brandedLocationId.value) {
          BrandedAppState.state.locationId = brandedLocationId.value;
          await BrandedAppState.getBrandedAppDetails(brandedLocationId.value);
        } else {
          await AppVersionsInstance.fetchAppVersions();
        }
      } catch (error) {
        console.error("Error getting branded location id", error);
        try {
          await AppVersionsInstance.fetchAppVersions();
        } catch (fetchError) {
          console.error("Error fetching app versions", fetchError);
        }
      }
    }
    const cookie = await getSessionCookies();
    if (routerInstance2) {
      AppState.setRouterInstance(routerInstance2);
    }
    try {
      await Promise.all([
        LocationState.getBrandingDetails(),
        UserState.getUserDetails()
      ]);
    } catch (error) {
      console.error("Error in getting location or user details", error);
    }
    if (!LocationState.state.locationId) {
      console.error("Location ID is required to initialize services");
    } else {
      initializeServices(LocationState.state.locationId);
    }
    if (cookie) {
      if (((_a = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a.userId) && ((_b = UserState == null ? void 0 : UserState.state) == null ? void 0 : _b.email)) {
        setUser(UserState.state.userId, UserState.state.email);
      }
      if (!AppVersionsInstance.isForceUpdateRequired) {
        await requestNotificationPermission();
      } else {
        try {
          await PushNotifications.removeAllDeliveredNotifications();
          await PushNotifications.removeAllListeners();
        } catch (error) {
          console.error("Error unregistering push notifications", error);
        }
      }
      if (!Capacitor.isNativePlatform()) {
        (_d = (_c = window == null ? void 0 : window.webkit) == null ? void 0 : _c.messageHandlers["push-permission-request"]) == null ? void 0 : _d.postMessage(
          "push-permission-request"
        );
        window == null ? void 0 : window.addEventListener("push-permission-request", (event) => {
          var _a2, _b2;
          const customEvent = event;
          if (customEvent && customEvent.detail) {
            switch (customEvent.detail) {
              case "granted":
                (_b2 = (_a2 = window == null ? void 0 : window.webkit) == null ? void 0 : _a2.messageHandlers["push-token"]) == null ? void 0 : _b2.postMessage(
                  "push-token"
                );
                break;
              default:
                console.error("permission denied by IOS");
                break;
            }
          }
        });
        window == null ? void 0 : window.addEventListener("push-token", (event) => {
          const customEvent = event;
          const token = customEvent == null ? void 0 : customEvent.detail;
          sendNotificationToken(token);
        });
        (_e = navigator == null ? void 0 : navigator.serviceWorker) == null ? void 0 : _e.addEventListener(
          "message",
          async (event) => await handleServiceWorkerMessage(event)
        );
        displayXVersions(AppState.state.NODE_ENV);
      }
    }
    return firebaseAppInstance;
  } catch (error) {
    console.error("Error in initializeApp:", error);
    throw error;
  }
}
async function sendNotificationToken(fcmToken) {
  var _a, _b;
  try {
    const cat = api.get("cat") || window.localStorage.getItem("cat");
    const cookie = cat ? JSON.parse(window.atob(cat)) : null;
    if (cookie == null ? void 0 : cookie.contactId) {
      const payload = {
        token: fcmToken
      };
      if (((_a = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _a.id) && Capacitor.getPlatform() === "ios") {
        payload["brandedAppId"] = (_b = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _b.id;
      }
      await UserService.updateSession(payload);
    }
  } catch (error) {
    console.error("Error sending FCM token", error);
  }
}
async function registerPushToken(registerPayload) {
  var _a, _b;
  try {
    const cookie = getSessionCookieData();
    if ((cookie == null ? void 0 : cookie.contactId) || (cookie == null ? void 0 : cookie.userId)) {
      const payload = {
        token: registerPayload.token,
        sessionId: cookie == null ? void 0 : cookie.sessionUniqueId,
        locationId: LocationState.state.locationId
      };
      if (((_a = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _a.id) && Capacitor.getPlatform() === "ios") {
        payload["brandedAppId"] = (_b = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _b.id;
      }
      if (isAuthV2Enabled()) {
        return AuthServiceV2.registerPushToken(payload);
      } else {
        return UserService.registerPushToken(payload);
      }
    } else {
      console.error("No contactId found for registerPushToken");
    }
  } catch (error) {
    console.error("Error sending FCM token in registerPushToken:", error);
  }
}
const handlePushNotificationClick = async (res) => {
  try {
    const { platform } = getPlatformDetails();
    const { notification, detail } = res || {};
    if (AppState.state.APP_NAME === ClientPortalApps.GOKOLLAB) {
      setPushNotificationData({
        notification,
        detail,
        nodeEnv: AppState.state.NODE_ENV,
        appName: AppState.state.APP_NAME,
        platform: Capacitor.getPlatform(),
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      });
    }
    console.log(
      "~ handlePushNotificationClick ~ :",
      notification,
      "detail:",
      detail
    );
    const {
      redirectPath,
      refId,
      "gcm.message_id": gcm_message_id,
      contactId,
      locationId,
      deviceType,
      appType,
      releaseVersionCode,
      notificationKey
    } = detail || (notification == null ? void 0 : notification.data) || {};
    try {
      await AnalyticsService.trackEventV2({
        indexName: ES_INDEXES.PUSH_NOTIFICATION_EVENT,
        locationId,
        contactId,
        status: ES_STATUSES.SUCCESS,
        logLevel: ES_LOG_LEVELS.INFO,
        eventData: {
          messageId: gcm_message_id,
          platform,
          refId,
          action: ES_PUSH_ACTION.CLICKED,
          redirectPath,
          deviceType,
          appType,
          releaseVersionCode,
          notificationKey
        }
      });
    } catch (e) {
      console.error("Error in trackEvent:", e);
    }
    await NotificationState.getUnreadNotificationsCount(99);
    await setBadgeCount(NotificationState.state.unReadNotificationCount - 1);
    if (refId) {
      setAppLoading(true);
      await NotificationState.markNotificationAsRead(void 0, refId);
      NotificationState.clearNotifications();
      await (NotificationState == null ? void 0 : NotificationState.getNotifications());
      setAppLoading(false);
    }
    if (redirectPath) {
      const isLocked = isLockout();
      if (isGokollab() || !isLocked) {
        window.location.href = `${window.location.origin}/${redirectPath}`;
      }
    }
  } catch (e) {
    console.error("Error in handlePushNotificationClick:", e);
  }
};
async function requestNotificationPermission() {
  try {
    if (Capacitor.isNativePlatform()) {
      await PushNotifications.addListener("registration", (token) => {
        console.info("Registration token: ", token.value);
      });
      await PushNotifications.addListener("registrationError", (err) => {
        console.error("Registration error: ", err.error);
      });
      let status = await PushNotifications.checkPermissions();
      if (status.receive === "prompt") {
        status = await PushNotifications.requestPermissions();
      }
      if (status.receive !== "granted") {
        console.error("User denied permissions!");
        throw new Error("User denied permissions!");
      }
      await PushNotifications.register();
      await new Promise((resolve) => setTimeout(resolve, 1e3));
      const result = await FCM.getToken();
      const fcmToken = result.token;
      await registerPushTokenWithRetry(
        fcmToken,
        MAX_REGISTER_PUSH_TOKEN_RETRIES
      );
      await PushNotifications.addListener(
        "pushNotificationReceived",
        async (notification) => {
          console.log("Push notification received", notification);
        }
      );
      await PushNotifications.addListener(
        "pushNotificationActionPerformed",
        handlePushNotificationClick
      );
      window.addEventListener(
        "notificationRedirect",
        handlePushNotificationClick
      );
      window.dispatchEvent(new Event("app-ready"));
    } else if (Capacitor.getPlatform() !== "ios") {
      if (isWebKit()) {
        console.warn(
          "Firebase messaging is not supported in WebKit browsers (iOS/Safari)"
        );
        return;
      }
      if (typeof Notification === "undefined") {
        console.warn("Notification API is not available in this environment");
        return;
      }
      if (!("serviceWorker" in navigator)) {
        console.warn("Service Worker API is not available in this environment");
        return;
      }
      await import("firebase/compat/messaging");
      const firebaseApp = getFirebaseAppInstance();
      const fcmInstance = await (firebaseApp == null ? void 0 : firebaseApp.messaging());
      if (fcmInstance) {
        Notification.requestPermission().then(async (notificationPermission) => {
          var _a, _b, _c;
          if (notificationPermission === "granted") {
            let fcmToken = await fcmInstance.getToken({
              vapidKey: (_a = AppState.getConfig()) == null ? void 0 : _a.webPushCertificate
            });
            fcmInstance.onMessage(async (payload) => {
              var _a2, _b2, _c2, _d, _e;
              if ((_a2 = navigator == null ? void 0 : navigator.serviceWorker) == null ? void 0 : _a2.getRegistrations()) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                const options = {
                  body: (_b2 = payload == null ? void 0 : payload.notification) == null ? void 0 : _b2.body,
                  image: (_c2 = payload == null ? void 0 : payload.notification) == null ? void 0 : _c2.image,
                  icon: (_d = payload == null ? void 0 : payload.notification) == null ? void 0 : _d.icon,
                  data: payload == null ? void 0 : payload.data
                };
                (_e = registrations[0]) == null ? void 0 : _e.showNotification(
                  payload.notification.title,
                  options
                );
              }
            });
            let retries = 0;
            while (retries < MAX_REGISTER_PUSH_TOKEN_RETRIES) {
              if (fcmToken) {
                try {
                  const registerResponse = await registerPushToken({
                    token: fcmToken
                  }).catch((e) => {
                    console.error("Error in registerPushToken for web:", e);
                  });
                  if ((_b = registerResponse == null ? void 0 : registerResponse.data) == null ? void 0 : _b.success) {
                    break;
                  } else {
                    const result = await fcmInstance.getToken({
                      vapidKey: (_c = AppState.getConfig()) == null ? void 0 : _c.webPushCertificate
                    });
                    fcmToken = result;
                  }
                } catch (e) {
                  console.error("Error in validate push token for web:", e);
                }
              }
              retries++;
              await new Promise((resolve) => setTimeout(resolve, 1e3));
            }
          } else {
            console.error("Unable to get permission to notify for web");
          }
        }).catch((error) => {
          console.error("Unable to get permission to notify for web", error);
        });
      } else {
        console.error("App not initialized for web");
      }
    }
  } catch (e) {
    console.error("Error in requestNotificationPermission", e);
  }
}
async function handleServiceWorkerMessage(event) {
  var _a, _b;
  if (!event.data.action) {
    return;
  }
  switch (event.data.action) {
    // handle notification click event from firebase sw
    case "redirect-from-notificationclick":
      if (AppVersionsInstance.isForceUpdateRequired) return;
      if ((_a = event.data) == null ? void 0 : _a.refId) {
        setAppLoading(true);
        await NotificationState.markNotificationAsRead(
          void 0,
          (_b = event.data) == null ? void 0 : _b.refId
        );
        NotificationState.clearNotifications();
        await (NotificationState == null ? void 0 : NotificationState.getNotifications());
        setAppLoading(false);
      }
      window.location.href = `${window.location.origin}/${event.data.redirectPath}`;
      break;
  }
}
function getFirebaseAppInstance() {
  return firebaseAppInstance;
}
const validatePwaAuth = async () => {
  if (!isPwa()) return true;
  try {
    const keys = Object.keys(localStorage);
    const tokenExists = keys.some((key) => key.startsWith("firebase:authUser:"));
    if (!tokenExists) {
      console.log(
        "%c Firebase Auth:",
        "background: #F44336; color: white; padding: 2px 5px; border-radius: 3px;",
        "No auth token found in localStorage"
      );
      AnalyticsService.trackEvent({
        eventName: "user-logout",
        locationId: "NA",
        groupId: "NA",
        contactId: "NA",
        eventData: {
          cat: await api.get("cat") || window.localStorage.getItem("cat")
        }
      }).catch((error) => {
        console.error("Error in trackEvent:", error);
      });
      await logoutUser$1();
      return false;
    }
    return true;
  } catch (error) {
    console.log(
      "%c Firebase Auth:",
      "background: #F44336; color: white; padding: 2px 5px; border-radius: 3px;",
      "Error checking authentication state"
    );
    console.error("Error in validatePwaAuth:", error);
    AnalyticsService.trackEvent({
      eventName: "user-logout",
      locationId: "NA",
      groupId: "NA",
      contactId: "NA",
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat"),
        error,
        source: "from validatePwaAuth catch block"
      }
    }).catch((error2) => {
      console.error("Error in trackEvent:", error2);
    });
    return false;
  }
};
const displayXVersions = (env) => {
  try {
    const isMobile = AppState.state.isMobile;
    const shouldShowVersions = !isMobile && (localStorage.getItem("show-versions") === "true" || env !== "production");
    if (!shouldShowVersions) return;
    const container = document.createElement("div");
    container.id = "x-version-display-container";
    document.body.appendChild(container);
    const versionApp = createApp(VersionDisplay, {
      environment: env
    });
    versionApp.mount("#x-version-display-container");
  } catch (error) {
    console.error("Error in displayXVersions:", error);
  }
};
const SwipeDirective = {
  mounted(el, binding) {
    let startX = 0;
    let startY = 0;
    const getDirection = (deltaX, deltaY) => {
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        return deltaX > 0 ? "right" : "left";
      } else {
        return deltaY > 0 ? "down" : "up";
      }
    };
    const handleTouchEnd = (event) => {
      const deltaX = event.changedTouches[0].clientX - startX;
      const deltaY = event.changedTouches[0].clientY - startY;
      const direction = getDirection(deltaX, deltaY);
      if (direction === binding.value.direction && binding.value.callback) {
        binding.value.callback();
      }
    };
    const handleMouseUp = (event) => {
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const direction = getDirection(deltaX, deltaY);
      if (direction === binding.value.direction && binding.value.callback) {
        binding.value.callback();
      }
    };
    el.addEventListener("touchstart", (event) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    });
    el.addEventListener("touchend", handleTouchEnd);
    el.addEventListener("mousedown", (event) => {
      startX = event.clientX;
      startY = event.clientY;
    });
    el.addEventListener("mouseup", handleMouseUp);
  },
  unmounted(el) {
    el.removeEventListener("touchstart", () => {
    });
    el.removeEventListener("touchend", () => {
    });
    el.removeEventListener("mousedown", () => {
    });
    el.removeEventListener("mouseup", () => {
    });
  }
};
const addChatWidgetPositioningScript = () => {
  const script = document.createElement("script");
  script.textContent = `
      window.addEventListener("LC_chatWidgetLoaded", function (e) {
    const container = e.detail;
    if (!container) return;

    // Style function to apply to the elements
    const applyCustomStyles = () => {
      const btn = container.querySelector(".lc_text-widget--bubble");
      const prompt = container.querySelector(".lc_text-widget--prompt");

      if (btn) {
        btn.style.setProperty("bottom", "60px", "important");
      }

      if (prompt) {
        prompt.style.setProperty("bottom", "40px", "important");
      }
    };

    // Apply styles initially (in case elements already exist)
    applyCustomStyles();

    // Set up MutationObserver to reapply styles if the widget re-renders
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const el = node;
            if (
              el.classList.contains("lc_text-widget--bubble") ||
              el.classList.contains("lc_text-widget--prompt") ||
              el.querySelector(".lc_text-widget--bubble") ||
              el.querySelector(".lc_text-widget--prompt")
            ) {
              applyCustomStyles();
            }
          }
        });
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });

    // Optional: store the observer on window for potential future cleanup
    window.__lcWidgetStyleObserver = observer;
  });
    `;
  document.head.appendChild(script);
};
const UserServiceV2 = {
  updateUser: async (payload) => {
    const response = await requests().put(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/users/${payload.userId}`,
      {
        email: payload.email,
        fullName: payload.fullName,
        termsConsent: payload.termsConsent,
        title: payload.title,
        bio: payload.bio,
        avatar: payload.avatar,
        profileCover: payload.profileCover,
        timeZone: payload.timeZone,
        password: payload.password,
        languagePreference: payload.languagePreference,
        newPassword: payload.newPassword,
        confirmPassword: payload.confirmPassword,
        location: payload.location,
        socials: payload.socials
      }
    );
    return response.data;
  },
  fetchUserDetails: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/users/${payload.userId}`
  ),
  getUserAnalytics: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/users-analytics/${payload.contactId}`
  ),
  getUserDomains: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/na/users/domains`,
    {
      email: payload.email
    }
  ),
  getContactDetails: (payload) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/users/contact/${payload.contactId}`
  ),
  updateUserSlug: async (locationId, slug) => {
    const response = await requests().patch(
      `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${locationId}/users/slug`,
      { slug }
    );
    return response.data;
  },
  changePassword: (payload) => requests().post(
    `${AppState.getConfig().REST_API_URLS}/clientclub/v2/${payload.locationId}/users/change-password/${payload.contactId}`,
    {
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword
    }
  )
};
var GAEventTypes = /* @__PURE__ */ ((GAEventTypes2) => {
  GAEventTypes2["CREATE_REACTIONS"] = "create-reactions-event";
  GAEventTypes2["DELETE_REACTIONS"] = "delete-reactions-event";
  GAEventTypes2["COMMENT_CREATED"] = "comment-created-event";
  GAEventTypes2["POST_CREATED"] = "post-created-event";
  GAEventTypes2["CHAT_MESSAGE_SENT"] = "chat-message-sent-event";
  GAEventTypes2["CHAT_MESSAGE_FAILED"] = "chat-message-failed-event";
  GAEventTypes2["CHAT_BLOCKED"] = "chat-blocked-event";
  GAEventTypes2["CHAT_CREATED"] = "chat-created-event";
  GAEventTypes2["EVENT_CREATED"] = "event-created-event";
  GAEventTypes2["EVENT_RSVP"] = "event-rsvp-event";
  GAEventTypes2["COMMUNITY_COURSE_OPENED"] = "community-course-opened-event";
  GAEventTypes2["GROUP_JOINED"] = "group-joined-event";
  GAEventTypes2["USER_BANNED"] = "user-banned-event";
  GAEventTypes2["MEDIA_REMOVED"] = "media-removed-event";
  GAEventTypes2["MEDIA_UPLOADED"] = "media-uploaded-event";
  GAEventTypes2["EVENT_ATTENDEES_LIST_EXPORTED"] = "event-attendees-list-exported-event";
  GAEventTypes2["EVENT_ATTENDEES_VIEWED"] = "event-attendees-viewed-event";
  GAEventTypes2["MEMBER_VIEWED_OWN_ANSWERS"] = "member-viewed-own-answers-event";
  GAEventTypes2["ADMIN_VIEWED_MEMBER_ANSWERS"] = "admin-viewed-member-answers-event";
  GAEventTypes2["GOKOLLAB_LISTING_JOINED"] = "gokollab-listing-joined-event";
  GAEventTypes2["GOKOLLAB_SEARCH"] = "gokollab-search-event";
  GAEventTypes2["FOLLOW"] = "follow-event";
  GAEventTypes2["UNFOLLOW"] = "unfollow-event";
  GAEventTypes2["COURSE_MENTIONED"] = "course-mentioned-event";
  GAEventTypes2["EVENT_MENTIONED"] = "event-mentioned-event";
  GAEventTypes2["CHANNEL_MENTIONED"] = "channel-mentioned-event";
  GAEventTypes2["GO_LIVE_SESSION_JOINED"] = "go-live-session-joined-event";
  GAEventTypes2["LESSON_OPENED"] = "lesson-opened-event";
  GAEventTypes2["LESSON_COMPLETED"] = "lesson-completed-event";
  GAEventTypes2["NEXT_LESSON"] = "next-lesson-event";
  GAEventTypes2["CUSTOM_LOGIN_EVENT"] = "custom-login-event";
  GAEventTypes2["LOGOUT"] = "logout-event";
  GAEventTypes2["CERTIFICATE_DOWNLOAD"] = "certificate-download-event";
  return GAEventTypes2;
})(GAEventTypes || {});
function enableAnalytics(contactId, appName = `Client Portal`, env = "staging") {
  var _a, _b;
  try {
    const environment = AppState.state.NODE_ENV || env;
    const isGtagInitialized = (_a = window.dataLayer) == null ? void 0 : _a.some(
      (item) => item[0] === "config" && [GTagID, COURSES_GTagID, CP_GOKOLLAB_GTagID].includes(item[1])
    );
    if (!contactId && !isGokollab() || isGtagInitialized) return;
    let gtagId = GTagID;
    if (isGokollab()) {
      appName = "Gokollab";
      const gtagConfig = (_b = window.dataLayer) == null ? void 0 : _b.filter(
        (items) => items[0] === "config"
      );
      if (!gtagConfig) {
        gtagId = GOKOLLAB_GTagID;
        setGtagOptions(contactId, gtagId, appName);
      }
      if (contactId) {
        if (window.gtag) {
          window.gtag("config", GOKOLLAB_GTagID, {
            user_id: contactId
          });
        } else {
          gtagId = GOKOLLAB_GTagID;
          setGtagOptions(contactId, gtagId, appName);
          if (environment === "production") {
            Y();
          }
        }
        gtagId = CP_GOKOLLAB_GTagID;
        setGtagOptions(contactId, gtagId, appName);
      }
    } else {
      if (appName === "Courses") {
        gtagId = COURSES_GTagID;
      }
      setGtagOptions(contactId, gtagId, appName);
    }
    if (environment !== "production") {
      console.log("gtag initialized", gtagId);
      return;
    }
    Y();
    if (contactId) {
      l("custom-login-event", {
        appName,
        user_id: contactId
      });
    }
  } catch (e) {
    console.error(e);
  }
}
function trackCustomGAEvents(eventName, eventParams = {}, env = "staging") {
  try {
    const environment = AppState.state.NODE_ENV || env;
    if (!eventName) return;
    if (environment !== "production") {
      console.log("custom ga events", eventName);
      return;
    }
    const cat = api.get("cat") || window.localStorage.getItem("cat");
    const catV2 = api.get("catv2") || window.localStorage.getItem("catv2");
    const cookie = cat ? JSON.parse(window.atob(cat)) : catV2 ? JSON.parse(window.atob(catV2)) : null;
    if (!(cookie == null ? void 0 : cookie.contactId)) {
      return;
    }
    l(eventName, {
      ...eventParams,
      user_id: cookie.contactId
    });
  } catch (e) {
    console.error(e);
  }
}
function setGtagOptions(contactId, gtagId, appName) {
  const payload = {
    appName,
    config: {
      id: gtagId,
      params: {
        send_page_view: true
      }
    }
  };
  if (contactId) {
    payload.config.params = {
      user_id: contactId
    };
  }
  G(payload);
}
function baseUrl() {
  try {
    const isDevelopment = window.location.origin.includes("localhost");
    if (isGokollab() && isDevelopment) {
      return "http://localhost:3032";
    }
    return window.location.origin;
  } catch (error) {
    console.error("Failed to get base URL:", error);
    return "";
  }
}
async function externalPathRedirect(path, query = "", newTab) {
  try {
    const domain = baseUrl();
    if (!domain) {
      throw new Error("Failed to get base URL");
    }
    if (!path) {
      throw new Error("Path is required for redirect");
    }
    const locationId = getSessionLocationId();
    if (locationId) {
      await AnalyticsService.trackPageViewEvents({
        locationId,
        eventType: CPPageEvents.USER_PAGE_HIT,
        route: path
      });
    }
    const finalUrl = query ? `${domain}/${path}?${query}` : `${domain}/${path}`;
    if (newTab) {
      const newWindow = window.open(finalUrl, "_blank");
      if (!newWindow) {
        window.location.href = finalUrl;
      }
    } else {
      window.location.href = finalUrl;
    }
  } catch (error) {
    console.error("Redirect failed:", error);
    throw error;
  }
}
async function handleLoginWithLoginCode(to, router) {
  try {
    const service = isGokollab() ? AuthServiceV2 : UserService;
    const { data } = await service.loginWithLoginCode({
      email: to.query.email || getQueryString(window.location.search, "email"),
      loginCode: to.query.loginCode,
      domainName: to.query.domain || window.location.hostname,
      locationId: isGokollab() ? getGokollabLocationId() : AppState.state.locationData.locationId
    });
    if (data.token) {
      await postLogin(data);
      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = urlParams.get("redirectUrl");
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else if (data.redirectUrl) {
        externalPathRedirect(data.redirectUrl, "");
      } else {
        router.push(isGokollab() ? "/" : { name: "AccountSetting" });
      }
    }
  } catch (ex) {
    console.error("Error ---->", ex);
    router.push({
      name: "Login",
      query: {
        redirectUrl: to.query.redirectUrl
      }
    });
  }
}
async function handleLoginWithMagicLink(to, router) {
  if (!isGokollab()) {
    return;
  }
  try {
    const { data } = await AuthServiceV2.loginWithMagicLink({
      email: to.query.email || getQueryString(window.location.search, "email"),
      token: to.query.token,
      domainName: to.query.domain || window.location.hostname,
      locationId: getGokollabLocationId()
    });
    if (data.token) {
      await postLogin(data);
      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = urlParams.get("redirectUrl");
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else if (data.redirectUrl) {
        externalPathRedirect(data.redirectUrl, "");
      } else {
        router.push(isGokollab() ? "/" : { name: "AccountSetting" });
      }
    }
  } catch (ex) {
    console.error("Error ---->", ex);
    router.push({
      name: "Login",
      query: {
        redirectUrl: to.query.redirectUrl
      }
    });
  }
}
function truncateString(inputString, stringSize) {
  if (inputString.length > stringSize) {
    return inputString.substring(0, stringSize) + "..";
  }
  return inputString;
}
function isEmptyObject(obj) {
  return obj.constructor === Object && Object.keys(obj).length === 0;
}
async function magicLinkLogin(to, from, router) {
  var _a, _b, _c;
  if (((_a = to.query) == null ? void 0 : _a.loginCode) && ((_b = to.query) == null ? void 0 : _b.email)) {
    to.query.email = to.fullPath.split("?email=")[1].split("&")[0];
    await handleLoginWithLoginCode(to, router);
  } else if ((_c = to.query) == null ? void 0 : _c.token) {
    await handleLoginWithMagicLink(to, router);
  }
}
const textValidation = string().required().test("is-text", "Special characters not supported", (value) => {
  return SANITIZE_REGEX_PATTERN.test(value);
});
const SANITIZE_REGEX_PATTERN = /^(?!.*(<(script|iframe|img|svg|object|embed|meta|form|link|style|base|applet|input|textarea|button|select|option|isindex|plaintext|math|video|audio|source|track|frame|frameset|bgsound|marquee|blink|xml|xss)[\s>]|javascript:|data:[^,]*[,;]|vbscript:|expression\(|\bon\w+=|eval\(|setTimeout\(|document\.cookie|window\.location|fetch\(|XMLHttpRequest|import\(\))).*$/i;
const validateForm = (root) => {
  return new Promise((resolve) => {
    root.getForm().validate().then(() => resolve(true)).catch((e) => {
      console.error("error", e);
      resolve(false);
    });
  });
};
const createElementId = (feature, component, element, suffix = "") => {
  const app = "app";
  const parts = [app, feature, component, element];
  if (suffix) parts.push(suffix);
  return parts.filter(Boolean).join("-");
};
class UsersState {
  constructor() {
    __publicField(this, "state", reactive({
      email: "",
      userId: "",
      locationId: "",
      fullName: "",
      title: "",
      bio: "",
      avatar: "",
      profileCover: "",
      role: "",
      timeZone: "",
      location: "",
      slug: "",
      termsConsent: "",
      languagePreference: "",
      billingTokenExpiry: null,
      billingToken: null,
      permissions: {
        affiliates: false,
        courses: false,
        communities: false
      },
      socials: {
        email: "",
        phoneNumber: "",
        facebook: "",
        twitter: "",
        instagram: "",
        linkedin: "",
        youtube: "",
        emailVisibility: "",
        phoneVisibility: ""
      },
      analytics: {
        groups: {
          joinedGroups: ""
        },
        affiliates: {
          earnings: ""
        },
        course: {
          coursesCompleted: ""
        }
      },
      groups: [],
      pinnedGroups: [],
      courses: [],
      pinnedCourses: []
    }));
    try {
      const storedBillingToken = localStorage.getItem("billingToken");
      if (storedBillingToken) {
        this.state.billingToken = storedBillingToken;
      }
    } catch (error) {
    }
  }
  saveBillingToken(token) {
    this.state.billingToken = token;
    try {
      localStorage.setItem("billingToken", token);
    } catch (error) {
    }
  }
  getBillingToken() {
    if (this.state.billingToken) {
      return this.state.billingToken;
    }
    try {
      const stored = localStorage.getItem("billingToken");
      if (stored) {
        this.state.billingToken = stored;
        return stored;
      }
    } catch (error) {
    }
    return null;
  }
  clearBillingToken() {
    this.state.billingToken = null;
    try {
      localStorage.removeItem("billingToken");
    } catch (error) {
    }
  }
  async getUserDetails() {
    try {
      const cookie = await getSessionCookieData();
      if ((cookie == null ? void 0 : cookie.locationId) && (cookie == null ? void 0 : cookie.contactId)) {
        let userData;
        if (isAuthV2Enabled()) {
          userData = await UserServiceV2.fetchUserDetails({
            userId: cookie.contactId,
            locationId: cookie.locationId
          });
        } else {
          userData = await UserService.fetchUserDetails({
            userId: cookie.contactId,
            locationId: cookie.locationId
          });
        }
        enableAnalytics(cookie.contactId);
        this.setProfileDetails({
          ...userData.data
        });
      } else {
        if (cookie && !isEmptyObject(cookie)) {
          localStorage.removeItem("cat");
          localStorage.removeItem("cat-v2");
          document.cookie = "cat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  setAvatar(value) {
    this.state.avatar = value;
  }
  setProfileDetails(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    this.state.userId = value == null ? void 0 : value.contactId;
    this.state.locationId = value == null ? void 0 : value.locationId;
    this.state.email = value == null ? void 0 : value.email;
    this.state.fullName = value == null ? void 0 : value.fullName;
    this.state.title = value == null ? void 0 : value.title;
    this.state.bio = value == null ? void 0 : value.bio;
    this.state.avatar = value == null ? void 0 : value.avatar;
    this.state.profileCover = value == null ? void 0 : value.profileCover;
    this.state.languagePreference = value == null ? void 0 : value.languagePreference;
    this.state.timeZone = value == null ? void 0 : value.timeZone;
    this.state.location = value == null ? void 0 : value.location;
    this.state.slug = value == null ? void 0 : value.slug;
    this.state.termsConsent = value == null ? void 0 : value.termsConsent;
    this.state.permissions.affiliates = ((_a = value == null ? void 0 : value.permissions) == null ? void 0 : _a.affiliates) || false;
    this.state.permissions.courses = ((_b = value == null ? void 0 : value.permissions) == null ? void 0 : _b.courses) || false;
    this.state.billingTokenExpiry = (value == null ? void 0 : value.billingTokenExpiry) || null;
    this.state.permissions.communities = ((_c = value == null ? void 0 : value.permissions) == null ? void 0 : _c.communities) || false;
    this.state.socials.phoneNumber = (_d = value == null ? void 0 : value.socials) == null ? void 0 : _d.phoneNumber;
    this.state.socials.facebook = (_e = value == null ? void 0 : value.socials) == null ? void 0 : _e.facebook;
    this.state.socials.twitter = (_f = value == null ? void 0 : value.socials) == null ? void 0 : _f.twitter;
    this.state.socials.instagram = (_g = value == null ? void 0 : value.socials) == null ? void 0 : _g.instagram;
    this.state.socials.youtube = (_h = value == null ? void 0 : value.socials) == null ? void 0 : _h.youtube;
    this.state.socials.linkedin = (_i = value == null ? void 0 : value.socials) == null ? void 0 : _i.linkedin;
    this.state.socials.email = (_j = value == null ? void 0 : value.socials) == null ? void 0 : _j.email;
    this.state.socials.emailVisibility = (_k = value == null ? void 0 : value.socials) == null ? void 0 : _k.emailVisibility;
    this.state.socials.phoneVisibility = (_l = value == null ? void 0 : value.socials) == null ? void 0 : _l.phoneVisibility;
    if (isGokollab()) {
      this.state.locationId = getGokollabLocationId();
    }
  }
  setProfileSlug(slug) {
    this.state.slug = slug;
  }
  setAnalytics(value) {
    var _a, _b, _c;
    this.state.analytics.affiliates.earnings = (_a = value == null ? void 0 : value.affiliates) == null ? void 0 : _a.earnings;
    this.state.analytics.course.coursesCompleted = (_b = value == null ? void 0 : value.course) == null ? void 0 : _b.coursesCompleted;
    this.state.analytics.groups.joinedGroups = (_c = value == null ? void 0 : value.groups) == null ? void 0 : _c.joinedGroups;
  }
  // add handling for isAuthV2Enabled
  async updateUserProfile(userData) {
    try {
      let user;
      if (isAuthV2Enabled()) {
        user = await UserServiceV2.updateUser({
          ...userData
        });
      } else {
        user = await UserService.updateUser({
          ...userData
        });
      }
      this.setProfileDetails(user);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async updateUserSlug(locationId, slug) {
    if (isAuthV2Enabled()) {
      const user = await UserServiceV2.updateUserSlug(locationId, slug);
      this.setProfileSlug(user.slug);
    } else {
      const user = await UserService.updateUserSlug(locationId, slug);
      this.setProfileSlug(user.slug);
    }
  }
  async changePassword(dataPayload) {
    try {
      if (isAuthV2Enabled()) {
        await UserServiceV2.changePassword({
          ...dataPayload
        });
      } else {
        await UserService.changePassword({
          ...dataPayload
        });
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getUserAnalytics(contactId, locationId) {
    try {
      const userAnalyticsData = await UserService.getUserAnalytics({
        contactId,
        locationId
      });
      this.setAnalytics(userAnalyticsData.data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getUserGroups() {
    try {
      if (this.state.groups && this.state.groups.length > 0) {
        return;
      }
      const userGroups = await CommunitiesService.getGroups(
        this.state.locationId
      );
      this.state.groups = userGroups;
      return userGroups;
    } catch (error) {
      console.error(error);
    }
  }
  async getPinnedGroups() {
    try {
      if (this.state.pinnedGroups && this.state.pinnedGroups.length > 0) {
        return;
      }
      const pinnedGroups = await CommunitiesService.getPinnedGroups(
        this.state.locationId
      );
      this.state.pinnedGroups = pinnedGroups;
    } catch (error) {
      console.error(error);
    }
  }
  async pinGroup(groupId) {
    var _a;
    try {
      const groupToPin = this.state.groups.find((group) => group._id === groupId);
      if (!groupToPin) {
        throw new Error("Group not found");
      }
      const pinnedGroup = {
        locationId: this.state.locationId,
        userReferenceId: "",
        source: "GOKOLLAB",
        entityType: "COMMUNITY",
        createdAt: (/* @__PURE__ */ new Date()).toISOString(),
        id: groupToPin._id,
        slug: groupToPin.slug,
        name: groupToPin.name,
        logo: (_a = groupToPin.branding) == null ? void 0 : _a.logo
      };
      this.state.pinnedGroups = [pinnedGroup, ...this.state.pinnedGroups];
      await CommunitiesService.pinGroup(this.state.locationId, groupId);
    } catch (error) {
      this.state.pinnedGroups = this.state.pinnedGroups.filter(
        (group) => group.id !== groupId
      );
      console.error(error);
      throw error;
    }
  }
  async unpinGroup(groupId) {
    const currentPinnedGroups = [...this.state.pinnedGroups];
    try {
      this.state.pinnedGroups = this.state.pinnedGroups.filter(
        (group) => group.id !== groupId
      );
      await CommunitiesService.unpinGroup(this.state.locationId, groupId);
    } catch (error) {
      this.state.pinnedGroups = currentPinnedGroups;
      console.error(error);
      throw error;
    }
  }
  async getCourses() {
    try {
      if (this.state.courses && this.state.courses.length > 0) {
        return;
      }
      const courses = await CoursesService.getCourses(this.state.locationId);
      this.state.courses = courses;
    } catch (error) {
      console.error(error);
    }
  }
  async getPinnedCourses() {
    try {
      if (this.state.pinnedCourses && this.state.pinnedCourses.length > 0) {
        return;
      }
      if (!this.state.courses || this.state.courses.length === 0) {
        await this.getCourses();
      }
      const pinnedCourses = await CoursesService.getPinnedCourses(
        this.state.locationId
      );
      this.state.pinnedCourses = pinnedCourses.map((pinnedCourse) => {
        var _a;
        const courseFromAll = (_a = this.state.courses) == null ? void 0 : _a.find(
          (c) => c.id === pinnedCourse.id
        );
        return {
          ...pinnedCourse,
          source: (courseFromAll == null ? void 0 : courseFromAll.source) ?? pinnedCourse.source
        };
      });
    } catch (error) {
      console.error(error);
    }
  }
  async pinCourse(courseId) {
    try {
      const courseToPin = this.state.courses.find(
        (course) => course.id === courseId
      );
      if (!courseToPin) {
        throw new Error("Course not found");
      }
      const pinnedCourse = {
        locationId: this.state.locationId,
        userReferenceId: "",
        source: courseToPin.source ?? "GOKOLLAB",
        entityType: "COMMUNITY",
        createdAt: (/* @__PURE__ */ new Date()).toISOString(),
        id: courseToPin.id,
        title: courseToPin.title,
        customization: courseToPin.customization
      };
      this.state.pinnedCourses = [pinnedCourse, ...this.state.pinnedCourses];
      await CoursesService.pinCourse(this.state.locationId, courseId);
    } catch (error) {
      this.state.pinnedCourses = this.state.pinnedCourses.filter(
        (course) => course.id !== courseId
      );
      console.error(error);
      throw error;
    }
  }
  async unpinCourse(courseId) {
    let currentPinnedCourses;
    try {
      currentPinnedCourses = [...this.state.pinnedCourses];
      this.state.pinnedCourses = this.state.pinnedCourses.filter(
        (course) => course.id !== courseId
      );
      await CoursesService.unpinCourse(this.state.locationId, courseId);
    } catch (error) {
      this.state.pinnedCourses = currentPinnedCourses;
      console.error(error);
      throw error;
    }
  }
}
function getUserData() {
  return { ...UserState.state };
}
const UserState = new UsersState();
const logoutUser$1 = async (autoLogout = false) => {
  try {
    if (!autoLogout) {
      AnalyticsService.trackEvent({
        eventName: "user-logout",
        locationId: getSessionLocationId(),
        groupId: "NA",
        contactId: getSessionUserId(),
        eventData: {
          cat: await api.get("cat") || window.localStorage.getItem("cat")
        }
      }).catch((error) => {
        console.error("Error in trackEvent:", error);
      });
    }
    captureMessage$1("logout user called", {
      level: "info"
    });
    localStorage.removeItem("event");
    localStorage.removeItem("cat");
    localStorage.removeItem("cat-v2");
    localStorage.removeItem("catv2");
    try {
      await deleteFCMToken();
    } catch (error) {
      console.error("Error deleting FCM token", error);
    }
    try {
      if (!autoLogout) {
        if (isAuthV2Enabled()) {
          const sessionData = getSessionCookieData();
          await AuthServiceV2.updateSession(
            {
              loggedIn: false,
              locationId: sessionData == null ? void 0 : sessionData.locationId
            },
            sessionData == null ? void 0 : sessionData.sessionUniqueId
          );
        } else {
          AppState.state.isLogoutUserCalled = true;
          await UserService.updateSession({
            loggedIn: false
          });
        }
      }
    } catch (error) {
      console.error("Error updating session", error);
    }
    await logoutUser();
  } catch (error) {
    console.error("Error logging out user");
  }
};
async function postLoginV2(data) {
  data["tokenExpirationTime"] = Date.now() + 23 * 60 * 60 * 1e3;
  console.log(":: tokenExpirationTime", data["tokenExpirationTime"]);
  api.set("catv2", window.btoa(JSON.stringify(data)), {
    expires: 365,
    sameSite: "None",
    secure: true
  });
  await requestNotificationPermission();
}
async function postLogin(data) {
  try {
    if (isGokollab()) {
      await postLoginV2(data);
      return;
    }
    addBreadcrumb({
      category: "auth",
      message: "Setting CAT token",
      level: "info",
      data: {
        operation: "set",
        tokenType: "cat",
        hasToken: !!data.token,
        timestamp: Date.now()
      }
    });
    try {
      const cookieData = {
        expires: 365
      };
      if (window.location.hostname !== "localhost") {
        cookieData.sameSite = "None";
        cookieData.secure = true;
      }
      api.set("cat", window.btoa(JSON.stringify(data)), cookieData);
    } catch (error) {
      console.error("Failed to set cookie", error);
      captureException$1(error, {
        tags: { error_type: "cat_token_storage_failed" }
      });
    }
    await firebase.auth().signInWithCustomToken(data.token).then(async () => {
    }).catch(function(error) {
      console.error(error);
    });
    await retryWithExponentialBackoff(async (retryAttempt) => {
      return await generateFirebaseToken(retryAttempt);
    });
    enableAnalytics(data.contactId);
    setUser(data.contactId, data.email);
    requestNotificationPermission();
  } catch (e) {
    console.error("Caught in postLogin", e);
  }
}
async function postLogoutV2() {
  trackCustomGAEvents(GAEventTypes.LOGOUT, {});
  api.remove("catv2");
  UserState.clearBillingToken();
}
const logoutUser = async (redirect = true) => {
  try {
    await AnalyticsService.trackEvent({
      eventName: "user-logout",
      locationId: getSessionLocationId(),
      groupId: "NA",
      contactId: getSessionUserId(),
      eventData: {
        cat: await api.get("cat") || window.localStorage.getItem("cat")
      }
    });
  } catch (error) {
    console.error("Error in trackEvent:", error);
  }
  try {
    const cookieData = {
      sameSite: "None",
      secure: true
    };
    api.remove("cat", cookieData);
    api.remove("cat-v2", cookieData);
  } catch (error) {
    console.error("Error removing CAT tokens", error);
  }
  try {
    await setBadgeCount(0);
  } catch (error) {
    console.error("Error setting badge count", error);
  }
  if (isAuthV2Enabled()) {
    try {
      postLogoutV2();
    } catch (error) {
      console.error("Error posting logout", error);
    }
    return;
  }
  try {
    trackCustomGAEvents(GAEventTypes.LOGOUT, {});
    const auth = AppState.getFirebaseAuthInstance();
    await auth.signOut();
  } catch (error) {
    console.error("Error logging out user", error);
  }
  if (redirect) {
    externalPathRedirect("login", "");
  }
};
function getQueryString(search, key) {
  const query = search.slice(search.indexOf("?") + 1, search.length);
  const queryArray = query.split("&");
  for (let i = 0; i < queryArray.length; i++) {
    const pair = queryArray[i].split("=");
    if (pair[0] === key) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}
async function handleRefreshToken() {
  try {
    const sessionData = getSessionCookieData();
    if (!sessionData && !(sessionData == null ? void 0 : sessionData.refreshToken)) {
      await logoutUser();
      return;
    }
    const refreshTokenResponse = await AuthServiceV2.refreshToken({
      refreshToken: sessionData.refreshToken,
      locationId: sessionData.locationId
    });
    sessionData.refreshToken = refreshTokenResponse.data.refreshToken;
    sessionData.sessionUniqueId = refreshTokenResponse.data.sessionUniqueId;
    sessionData.token = refreshTokenResponse.data.token;
    await postLoginV2(sessionData);
    return refreshTokenResponse.data.token;
  } catch (error) {
    captureException$1(error, {
      tags: { error_type: "refresh_token_v2_failed" }
    });
    await logoutUser();
    console.error(error);
  }
}
function getPlatformDetails() {
  try {
    const platform = Capacitor.getPlatform() || null;
    return {
      platform
    };
  } catch (error) {
    console.error("Error in getPlatformDetails:", error);
    return {
      platform: "error"
    };
  }
}
const getHeader = () => {
  var _a;
  const headers = {
    channel: "APP",
    source: "PORTAL_USER",
    version: "2021-04-15",
    "x-middleware": "cp-core",
    "x-request-source": AppState.state.APP_NAME,
    "x-cp-build-version": "3.2.39",
    "x-platform-details": ((_a = getPlatformDetails()) == null ? void 0 : _a.platform) || null
  };
  return headers;
};
const MAX_RETRIES = 3;
const INITIAL_DELAY = 700;
const BACKOFF_RATE = 2;
async function retryWithExponentialBackoff(operation, retryAttempt = 1) {
  try {
    return await operation(retryAttempt);
  } catch (error) {
    if (retryAttempt >= MAX_RETRIES) {
      throw error;
    }
    const delay = INITIAL_DELAY * Math.pow(BACKOFF_RATE, retryAttempt - 1);
    await new Promise((resolve) => setTimeout(resolve, delay));
    return retryWithExponentialBackoff(operation, retryAttempt + 1);
  }
}
async function generateFirebaseToken(retryAttempt = 1) {
  var _a, _b, _c, _d;
  try {
    if (!((_a = firebase) == null ? void 0 : _a.apps) || !((_c = (_b = firebase) == null ? void 0 : _b.apps) == null ? void 0 : _c.length)) {
      withScope((scope) => {
        scope.setTag("error_type", "firebase_not_initialized");
        captureMessage$1("Firebase not initialized", "error");
      });
      throw new Error("Firebase not initialized");
    }
    if (!((_d = firebase) == null ? void 0 : _d.app)) {
      withScope((scope) => {
        scope.setTag("error_type", "firebase_app_missing");
        captureMessage$1("Firebase app instance not found", "error");
      });
      throw new Error("Firebase app instance not found");
    }
    const auth = AppState.getFirebaseAuthInstance();
    const cat = await api.get("cat") || window.localStorage.getItem("cat");
    addBreadcrumb({
      category: "auth",
      message: "CAT token retrieval attempt",
      level: "info",
      data: {
        source: api.get("cat") ? "cookie" : window.localStorage.getItem("cat") ? "localStorage" : "none"
      }
    });
    let firebaseToken = null;
    try {
      firebaseToken = cat ? JSON.parse(window.atob(cat)) : null;
    } catch (error) {
      captureException$1(error, {
        tags: { error_type: "cat_token_parse_failed" }
      });
      throw new Error("Failed to parse CAT token", { cause: error });
    }
    const { platform } = getPlatformDetails();
    const authState = (auth == null ? void 0 : auth.currentUser) ? "signed-in" : "signed-out";
    let tokenId = null;
    if (!(auth == null ? void 0 : auth.currentUser) && firebaseToken) {
      tokenId = await handleRefreshTokenFirebase(
        firebaseToken,
        auth,
        { platform, authState },
        retryAttempt
      );
    }
    const keyToken = tokenId || await handleKeyToken(firebaseToken, auth);
    if (!keyToken && firebaseToken) {
      throw new Error("Missing key token after handleKeyToken", {
        cause: new Error("Key token missing")
      });
    }
    if (firebaseToken) {
      trackGenerateTokenSuccess("Success in handleKeyToken").catch((error) => {
        console.error("Error in trackGenerateTokenSuccess:", error);
      });
    }
    return keyToken;
  } catch (error) {
    console.error("Error in generateToken:", error);
    await trackGenerateTokenFailed(
      "Error in generateToken",
      error,
      retryAttempt
    ).catch((error2) => {
      console.error("Error in trackGenerateTokenFailed:", error2);
    });
    throw error;
  }
}
async function handleKeyToken(firebaseToken, auth) {
  var _a;
  try {
    const keyToken = await ((_a = auth == null ? void 0 : auth.currentUser) == null ? void 0 : _a.getIdToken(true));
    addBreadcrumb({
      category: "auth",
      message: "ID token generation attempt",
      level: "info",
      data: {
        success: !!keyToken,
        userAuthenticated: !!auth.currentUser
      }
    });
    if (keyToken && firebaseToken) {
      firebaseToken["tokenId"] = keyToken;
      firebaseToken["tokenExpirationTime"] = AppState.state.NODE_ENV !== "production" ? Date.now() + 2 * 60 * 1e3 : jwtDecode(keyToken).exp * 1e3;
      try {
        const cookieData = {
          expires: 365
        };
        if (window.location.hostname !== "localhost") {
          cookieData.sameSite = "None";
          cookieData.secure = true;
        }
        await api.set(
          "cat",
          window.btoa(JSON.stringify(firebaseToken)),
          cookieData
        );
      } catch (error) {
        captureException$1(error, {
          tags: { error_type: "token_storage_failed" }
        });
      }
    }
    return keyToken;
  } catch (error) {
    captureException$1(error, {
      tags: {
        error_type: "token_generation_failed"
      },
      extra: {
        error_code: error == null ? void 0 : error.code,
        error_message: error == null ? void 0 : error.message
      }
    });
    console.error("Error in handleKeyToken:", error);
    throw error;
  }
}
let refreshTokenPromise = null;
let refreshTokenV2Promise = null;
async function refreshV2TokenSingleFlight() {
  if (!refreshTokenV2Promise) {
    const runRefresh = async () => {
      try {
        const refreshed = await handleRefreshToken();
        return refreshed;
      } finally {
        refreshTokenV2Promise = null;
      }
    };
    refreshTokenV2Promise = runRefresh();
  }
  return await refreshTokenV2Promise;
}
async function handleRefreshTokenFirebase(firebaseToken, auth, { platform, authState }, retryAttempt = 1) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (!(auth == null ? void 0 : auth.currentUser) && firebaseToken) {
    try {
      const decodedToken = jwtDecode(firebaseToken == null ? void 0 : firebaseToken.token);
      const locationId = (_a = decodedToken == null ? void 0 : decodedToken.claims) == null ? void 0 : _a.locationId;
      const contactId = (_b = decodedToken == null ? void 0 : decodedToken.claims) == null ? void 0 : _b.contact_id;
      if (!locationId || !contactId) {
        throw new Error(
          "Missing locationId or contactId in token - handleRefreshTokenFirebase"
        );
      }
      if (!refreshTokenPromise) {
        refreshTokenPromise = UserService.refreshFirebaseToken({
          token: firebaseToken == null ? void 0 : firebaseToken.token,
          locationId: locationId || "",
          contactId: contactId || "",
          platform: platform || "",
          authState: authState || "",
          retryAttempt
        }).finally(() => {
          refreshTokenPromise = null;
        });
      }
      const response = await refreshTokenPromise;
      if ((_c = response == null ? void 0 : response.data) == null ? void 0 : _c.token) {
        firebaseToken["token"] = (_d = response == null ? void 0 : response.data) == null ? void 0 : _d.token;
        firebaseToken["tokenId"] = (_e = response == null ? void 0 : response.data) == null ? void 0 : _e.tokenId;
        firebaseToken["tokenExpirationTime"] = ((_f = response == null ? void 0 : response.data) == null ? void 0 : _f.tokenId) ? AppState.state.NODE_ENV !== "production" ? Date.now() + 2 * 60 * 1e3 : jwtDecode((_g = response == null ? void 0 : response.data) == null ? void 0 : _g.tokenId).exp * 1e3 : void 0;
        const cookieData = {
          expires: 365
        };
        if (window.location.hostname !== "localhost") {
          cookieData.sameSite = "None";
          cookieData.secure = true;
        }
        await api.set(
          "cat",
          window.btoa(JSON.stringify(firebaseToken)),
          cookieData
        );
        if ((_h = response == null ? void 0 : response.data) == null ? void 0 : _h.tokenId) {
          return (_i = response == null ? void 0 : response.data) == null ? void 0 : _i.tokenId;
        }
        try {
          await signInWithCustomToken(auth, (_j = response == null ? void 0 : response.data) == null ? void 0 : _j.token);
        } catch (error) {
          throw new Error(
            "Failed to sign in with custom token - handleRefreshTokenFirebase",
            error
          );
        }
      } else {
        throw new Error(
          "No token in refresh response - handleRefreshTokenFirebase"
        );
      }
    } catch (error) {
      console.error("Error in refresh token:", error);
      throw error;
    }
  }
}
async function getTokenV2() {
  try {
    const cat = api.get("catv2") || window.localStorage.getItem("catv2");
    const data = cat ? JSON.parse(window.atob(cat)) : null;
    if (!(data == null ? void 0 : data.token) || !(data == null ? void 0 : data.tokenExpirationTime)) {
      return;
    }
    if (parseInt(data == null ? void 0 : data.tokenExpirationTime) > Date.now()) {
      return `Bearer ${data == null ? void 0 : data.token}`;
    } else {
      console.log(":: getTokenV2 - Token expired; checking in-flight refresh");
      const token = await refreshV2TokenSingleFlight();
      console.log(":: getTokenV2 - refreshed successfully, returning Bearer");
      return `Bearer ${token}`;
    }
  } catch (error) {
    captureException$1(error, {
      tags: { error_type: "get_token_v2_failed" }
    });
    console.error(":: getTokenV2 - Error occurred:", error);
    throw error;
  }
}
async function getToken() {
  try {
    if (isGokollab()) {
      const token = await getTokenV2();
      return token;
    }
    const cat = api.get("cat") || window.localStorage.getItem("cat");
    addBreadcrumb({
      category: "auth",
      message: "Token retrieval attempt",
      level: "info",
      data: {
        source: api.get("cat") ? "cookie" : window.localStorage.getItem("cat") ? "localStorage" : "none"
      }
    });
    let firebaseToken = null;
    try {
      firebaseToken = cat ? JSON.parse(window.atob(cat)) : null;
    } catch (error) {
      captureException$1(error, {
        tags: { error_type: "token_parse_failed" }
      });
    }
    if ((firebaseToken == null ? void 0 : firebaseToken.tokenId) && parseInt(firebaseToken.tokenExpirationTime) > Date.now()) {
      return firebaseToken.tokenId;
    } else {
      addBreadcrumb({
        category: "auth",
        message: "Token refresh needed",
        level: "info",
        data: {
          hasTokenId: !!(firebaseToken == null ? void 0 : firebaseToken.tokenId),
          isExpired: (firebaseToken == null ? void 0 : firebaseToken.tokenExpirationTime) ? parseInt(firebaseToken.tokenExpirationTime) <= Date.now() : true
        }
      });
      try {
        const newToken = await retryWithExponentialBackoff(
          async (retryAttempt) => {
            return await generateFirebaseToken(retryAttempt);
          }
        );
        return newToken;
      } catch (error) {
        withScope((scope) => {
          scope.setTag("error_type", "token_generation_failed_after_retries");
          scope.setExtra("error", error);
          scope.setExtra("maxRetries", MAX_RETRIES);
          captureMessage$1(
            "Token generation failed after all retries",
            "error"
          );
        });
        await trackAutoLogout(
          "Auto Logout (getToken) - Token generation failed after retries",
          error
        ).catch((trackError) => {
          console.error("Error in trackAutoLogout:", trackError);
        });
        await logoutUser$1(true);
        return void 0;
      }
    }
  } catch (error) {
    captureException$1(error, {
      tags: { error_type: "get_token_failed" }
    });
    console.error("Error in getToken:", error);
    return void 0;
  }
}
async function handleGoKollabRequests(requestConfig) {
  var _a, _b, _c, _d, _e;
  if (!isGokollab()) {
    return requestConfig;
  }
  if (requestConfig.url.includes("/gokollab/")) {
    return requestConfig;
  }
  requestConfig.url = requestConfig.url.replace(
    "/communities/",
    "/gokollab/communities/"
  );
  requestConfig.baseURL = ((_a = requestConfig.baseURL) == null ? void 0 : _a.replace("/communities", "/gokollab/communities")) || requestConfig.baseURL;
  if (requestConfig.url.includes("/gokollab/communities/")) {
    requestConfig.headers.marketplaceId = "APP";
  }
  requestConfig.url = requestConfig.url.replace(
    "/assets-drm/",
    "/gokollab/assets-drm/"
  );
  requestConfig.baseURL = ((_b = requestConfig.baseURL) == null ? void 0 : _b.replace("/assets-drm", "/gokollab/assets-drm")) || requestConfig.baseURL;
  requestConfig.url = requestConfig.url.replace(
    "/membership/",
    "/gokollab/memberships/"
  );
  requestConfig.baseURL = ((_c = requestConfig.baseURL) == null ? void 0 : _c.replace("/membership", "/gokollab/memberships")) || requestConfig.baseURL;
  requestConfig.url = requestConfig.url.replace(
    "/courses/learners",
    "/gokollab/courses/learners"
  );
  requestConfig.baseURL = ((_d = requestConfig.baseURL) == null ? void 0 : _d.replace(
    "/courses/learners",
    "/gokollab/courses/learners"
  )) || requestConfig.baseURL;
  requestConfig.url = requestConfig.url.replace(
    "/certificates/",
    "/gokollab/certificates/"
  );
  requestConfig.baseURL = ((_e = requestConfig.baseURL) == null ? void 0 : _e.replace("/certificates", "/gokollab/certificates")) || requestConfig.baseURL;
  return requestConfig;
}
async function axiosRequestMiddleware(requestConfig) {
  try {
    setContext("request", {
      url: requestConfig.url,
      method: requestConfig.method,
      timestamp: Date.now()
    });
    if (requestConfig.url.includes("users") && isAuthV2Enabled()) {
      requestConfig.baseURL = requestConfig.baseURL.replace(
        "/clientclub",
        "/clientclub/v2"
      );
    }
    if (requestConfig.url.includes("/clientclub/auth/refresh-token") || requestConfig.url.includes("/clientclub/v2/") && requestConfig.url.includes("refresh-token") || requestConfig.url.includes("portal-settings") || requestConfig.url.includes("/clientclub/v2/") && requestConfig.url.includes("refresh-token") || requestConfig.url.includes("/communities/analytics/track-event")) {
      return requestConfig;
    }
    const keyToken = await getToken();
    addBreadcrumb({
      category: "request",
      message: "Token check for request",
      level: "info",
      data: {
        hasToken: !!keyToken,
        url: requestConfig.url,
        method: requestConfig.method,
        headers: (requestConfig == null ? void 0 : requestConfig.headers["authorization"]) || (requestConfig == null ? void 0 : requestConfig.headers["token-id"])
      }
    });
    if (!keyToken) {
      const cat = api.get("cat") || window.localStorage.getItem("cat");
      const firebaseToken = cat ? JSON.parse(window.atob(cat)) : null;
      if (firebaseToken) {
        withScope((scope) => {
          scope.setExtra("url", requestConfig.url);
          scope.setExtra("method", requestConfig.method);
          scope.setExtra("headers", Object.keys(requestConfig.headers || {}));
          captureMessage$1("Missing token in request", "error");
        });
      }
    }
    if (keyToken && isAuthV2Enabled()) {
      requestConfig.headers["authorization"] = `${keyToken}`;
    } else if (keyToken) {
      requestConfig.headers["token-id"] = `${keyToken}`;
    }
    requestConfig = await handleGoKollabRequests(requestConfig);
    addBreadcrumb({
      category: "request",
      message: `Request ready ${requestConfig.url}`,
      level: "info",
      data: {
        hasAuthHeader: !!(requestConfig.headers["authorization"] || requestConfig.headers["token-id"]),
        finalUrl: requestConfig.url
      }
    });
    return requestConfig;
  } catch (error) {
    captureException$1(error, {
      tags: {
        error_type: "request_middleware_failed",
        endpoint: requestConfig.url
      },
      extra: {
        url: requestConfig.url,
        method: requestConfig.method,
        headers: Object.keys(requestConfig.headers || {})
      }
    });
    console.error("Error in axiosRequestMiddleware:", error);
    return requestConfig;
  }
}
const axiosResponseMiddleware = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const originalRequest = error.config;
      const isConnectionAbort = error.code === NETWORK_ERROR_CODES.ECONNABORTED || error.code === NETWORK_ERROR_CODES.ERR_NETWORK || error.code === NETWORK_ERROR_CODES.ERR_INTERNET_DISCONNECTED || ((_a = error.response) == null ? void 0 : _a.status) === 0 || ((_b = error.message) == null ? void 0 : _b.toLowerCase().includes("timeout")) || ((_c = error.message) == null ? void 0 : _c.toLowerCase().includes("abort")) || ((_d = error.message) == null ? void 0 : _d.toLowerCase().includes("network error"));
      const ignoreFromSentry = (((_f = (_e = error == null ? void 0 : error.message) == null ? void 0 : _e.toLowerCase()) == null ? void 0 : _f.includes("network error")) || (error == null ? void 0 : error.code) === NETWORK_ERROR_CODES.ERR_NETWORK) && isWebKit();
      if (isConnectionAbort) {
        if (!ignoreFromSentry) {
          withScope((scope) => {
            scope.setLevel(SCOPE_LEVEL.WARNING);
            captureException$1(error, {
              tags: {
                error_type: NEWTORK_ERROR_TYPES.CONNECTION_ABORT,
                error_code: error.code
              },
              extra: {
                url: originalRequest == null ? void 0 : originalRequest.url,
                method: originalRequest == null ? void 0 : originalRequest.method,
                timeout: originalRequest == null ? void 0 : originalRequest.timeout,
                message: error.message
              }
            });
          });
        }
        console.warn("Connection aborted:", {
          url: originalRequest == null ? void 0 : originalRequest.url,
          code: error.code,
          message: error.message
        });
        return Promise.reject(error);
      }
      const cat = await api.get("cat") || window.localStorage.getItem("cat");
      let firebaseToken = null;
      try {
        firebaseToken = cat ? JSON.parse(window.atob(cat)) : null;
      } catch (error2) {
        console.error(
          "Error in json parsing in axiosResponseMiddleware:",
          error2
        );
      }
      if (originalRequest && (((_g = error.response) == null ? void 0 : _g.status) !== 401 || originalRequest._retry)) {
        return Promise.reject(error);
      }
      originalRequest._retry = true;
      if (firebaseToken) {
        try {
          const newToken = await retryWithExponentialBackoff(
            async (retryAttempt) => {
              return await generateFirebaseToken(retryAttempt);
            }
          );
          if (!newToken) {
            throw new Error("Failed to refresh token");
          }
          if (isAuthV2Enabled()) {
            originalRequest.headers["authorization"] = `${newToken}`;
          } else {
            originalRequest.headers["token-id"] = `${newToken}`;
          }
          return Promise.reject(error);
        } catch (error2) {
          await trackAutoLogout(
            "Auto Logout (interceptor) - Token generation failed after retries",
            error2
          ).catch((trackError) => {
            console.error("Error in trackAutoLogout:", trackError);
          });
          await logoutUser$1(true);
          return Promise.reject(error2);
        }
      }
    }
  );
};
const requests = (host) => {
  const baseUrl2 = host || AppState.getConfig().REST_API_URLS;
  const axiosInstance = axios.create({
    baseURL: baseUrl2,
    headers: getHeader()
  });
  axiosInstance.interceptors.request.use(async (requestConfig) => {
    try {
      requestConfig = await axiosRequestMiddleware(requestConfig);
    } catch (e) {
      console.error("Error in request middleware:", e);
      captureException$1(e, {
        extra: {
          url: requestConfig.url,
          method: requestConfig.method
        }
      });
    }
    return requestConfig;
  });
  axiosResponseMiddleware(axiosInstance);
  return axiosInstance;
};
const BrandedAppService = {
  getAppDetails: (locationId) => requests().get(
    `${AppState.getConfig().REST_API_URLS}/clientclub/branded-app/${locationId}/customization`
  )
};
class BrandedAppsState {
  constructor() {
    __publicField(this, "state", reactive({
      id: "",
      status: "",
      locationId: "",
      appName: "",
      primaryColor: "",
      appIconImage: "",
      appCarouselImage1: "",
      appCarouselDescription1: "",
      appCarouselImage2: "",
      appCarouselDescription2: "",
      appCarouselImage3: "",
      appCarouselDescription3: "",
      appCarouselImage4: "",
      appCarouselDescription4: "",
      privacyPolicyUrl: "",
      termsConditionsUrl: ""
    }));
  }
  setBrandedAppDetails(data) {
    if (!data) return;
    const {
      appName = "",
      primaryColor = "",
      appIconImage = "",
      appCarouselImage1 = "",
      appCarouselDescription1 = "",
      appCarouselImage2 = "",
      appCarouselDescription2 = "",
      appCarouselImage3 = "",
      appCarouselDescription3 = "",
      appCarouselImage4 = "",
      appCarouselDescription4 = "",
      privacyPolicyUrl = "",
      termsConditionsUrl = ""
    } = data;
    Object.assign(this.state, {
      appName,
      primaryColor,
      appIconImage,
      appCarouselImage1,
      appCarouselDescription1,
      appCarouselImage2,
      appCarouselDescription2,
      appCarouselImage3,
      appCarouselDescription3,
      appCarouselImage4,
      appCarouselDescription4,
      privacyPolicyUrl,
      termsConditionsUrl
    });
  }
  /**
   * Get branded app details from API and process version information
   * @param locationId Location ID for branded app
   */
  async getBrandedAppDetails(locationId) {
    try {
      const response = await BrandedAppService.getAppDetails(locationId);
      const {
        _id,
        status,
        appDetails,
        releasedAppVersions,
        minimumAppVersions,
        playStoreAppLink,
        appStoreAppLink
      } = response.data || {};
      this.state.id = _id || "";
      this.state.status = status || "";
      this.setBrandedAppDetails(appDetails);
      this.processVersionInfo(
        releasedAppVersions,
        minimumAppVersions,
        playStoreAppLink,
        appStoreAppLink
      );
    } catch (error) {
      console.error("Error fetching branded app details:", error);
    }
  }
  /**
   * Process version information and check compatibility
   * @param appStoreVersionCodes App store version codes
   * @param minimumVersionCode Minimum version codes
   * @param playStoreAppLink Android app link
   * @param appStoreAppLink iOS app link
   */
  async processVersionInfo(appStoreVersionCodes, minimumVersionCode, playStoreAppLink, appStoreAppLink) {
    const formattedAppStoreVersions = appStoreVersionCodes ? {
      android: appStoreVersionCodes.android ?? -1,
      ios: appStoreVersionCodes.ios ?? -1
    } : void 0;
    const formattedMinimumVersions = minimumVersionCode ? {
      android: minimumVersionCode.android ?? -1,
      ios: minimumVersionCode.ios ?? -1
    } : void 0;
    AppVersionsInstance.updateAppVersions(
      formattedAppStoreVersions,
      formattedMinimumVersions
    );
    await AppVersionsInstance.checkAppVersionCompatibility(
      playStoreAppLink,
      appStoreAppLink
    );
  }
}
const BrandedAppState = new BrandedAppsState();
const isLockout = () => {
  return BrandedAppState.state.status === ApplicationStatus.CANCELLED;
};
export {
  CP_Pendo_Events as $,
  AppState as A,
  BRANDED_TEST_EMAIL_ID as B,
  CoursesService as C,
  DISCOVER_ICON as D,
  COMMUNITIES_ICON as E,
  BrandedAppState as F,
  externalPathRedirect as G,
  setAppLoading as H,
  NotificationState as I,
  JCB_ICON as J,
  KOLAB_IMAGE as K,
  LocationState as L,
  MASTERCARD_ICON as M,
  NO_CERTIFICATES_THUMBNAIL as N,
  OpenInNativeAppWhitelist as O,
  setBadgeCount as P,
  MAX_BADGE_COUNT_LIMIT as Q,
  FACEBOOK_ICON as R,
  SANITIZE_REGEX_PATTERN as S,
  TEST_EMAILS as T,
  UserState as U,
  VISA_ICON as V,
  INSTAGRAM_ICON as W,
  LINKEDIN_ICON as X,
  TWITTER_ICON as Y,
  YOUTUBE_ICON as Z,
  trackPendoEvents as _,
  isMobileTablet as a,
  removePushNotificationData as a$,
  ProfileScreen as a0,
  addChatWidgetPositioningScript as a1,
  NETWORK_ERROR_CODES as a2,
  Screens as a3,
  LoginEvents as a4,
  postLogin as a5,
  textValidation as a6,
  handleRedirectToExternalBrowser as a7,
  EMPTY_FOLDER as a8,
  AnalyticsService as a9,
  DEFAULT_GROUP_LOGO as aA,
  DEFAULT_GROUP_COVER_IMAGE as aB,
  checkUserConsent as aC,
  FRAME1 as aD,
  FRAME2 as aE,
  FRAME3 as aF,
  FRAME4 as aG,
  MAIL_MOBILE_ICON as aH,
  TEST_LOCATION_ID as aI,
  GROUP_MOBILE_ICON as aJ,
  GAEventTypes as aK,
  axiosRequestMiddleware as aL,
  axiosResponseMiddleware as aM,
  enableAnalytics as aN,
  fetchPortalSetting as aO,
  generateFirebaseToken as aP,
  getHostName as aQ,
  getLocationData as aR,
  getLocationId as aS,
  getPushNotificationRedirectPath as aT,
  getSessionLocationId as aU,
  getToken as aV,
  getTokenV2 as aW,
  getUserData as aX,
  isLockout as aY,
  logoutUser as aZ,
  magicLinkLogin as a_,
  UserPlatform as aa,
  CPPageEvents as ab,
  EstimateStatus as ac,
  DEFAULT_COVER as ad,
  isAppLoading as ae,
  EMPTY_STATE as af,
  GROUP_BRANDING_NAVBAR as ag,
  DEFAULT_AVATAR as ah,
  AppVersionsInstance as ai,
  WINDOW_EVENTS as aj,
  trackForceUpdateEvent as ak,
  ForceUpdateEvents as al,
  FORCE_APP_UPDATE_BG as am,
  GOKOLLAB_GRADIENT_LOGO as an,
  GOKOLLAB_LOGO as ao,
  GOKOLLAB_DEFAULT_LOGO as ap,
  createElementId as aq,
  DEFAULT_COURSE_LOGO as ar,
  DEFAULT_COMMUNITY_LOGO as as,
  GOKOLLAB_K_LOGO_WITHOUT_BORDER as at,
  EXPLORE_ICON as au,
  ADD_ICON as av,
  GOKOLLAB_MASTERMIND_LOGO as aw,
  LOGIN_LOGO as ax,
  SIGN_UP_LOGO as ay,
  LOCKOUT_IMAGE as az,
  isPwa as b,
  trackAutoLogoutFromCommunities as b0,
  trackCustomGAEvents as b1,
  SwipeDirective as b2,
  ClientPortalApps as b3,
  setTag as b4,
  captureMessage as b5,
  captureException as b6,
  getFirebaseAppInstance as b7,
  handleServiceWorkerMessage as b8,
  initializeApp as b9,
  registerPushToken as ba,
  requestNotificationPermission as bb,
  sendNotificationToken as bc,
  validatePwaAuth as bd,
  getSessionContactId as be,
  getSessionCookieData as bf,
  getSessionCookies as bg,
  isGokollabMobile as bh,
  isMobileOs as bi,
  isWebKit as bj,
  AuthServiceV2 as bk,
  postLoginV2 as bl,
  TEST_EMAIL_ID as c,
  deviceId as d,
  UserService as e,
  formatDateDay as f,
  getGokollabLocationId as g,
  CAPACITOR_PLATFORM as h,
  isGokollab as i,
  CARD_ICON as j,
  UNIONPAY_ICON as k,
  DINERS_ICON as l,
  AMEX_ICON as m,
  LANDING_PAGE_IMAGE as n,
  formatDate as o,
  DEFAULT_CERTIFICATE_THUMBNAIL as p,
  CommunitiesService as q,
  requests as r,
  logoutUser$1 as s,
  truncateString as t,
  ALLOWED_FILE_TYPES as u,
  validateForm as v,
  MediaService2 as w,
  isAuthV2Enabled as x,
  UserServiceV2 as y,
  COURSES_ICON as z
};
